var _g, _g2, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _mask, _path29, _path30, _rect2, _g3, _rect3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _rect4, _g4, _mask2, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _rect5, _path62, _path63, _path64, _g5, _rect6, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _rect7, _g6, _mask3, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _rect8, _path85, _path86, _path87, _g7, _rect9, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _rect10, _g8, _rect11, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _mask4, _path123, _path124, _rect12, _g9, _rect13, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _rect14, _rect15, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _rect16, _rect17, _path156, _rect18, _rect19, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _mask5, _path181, _path182, _rect20, _rect21, _mask6, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _rect22, _path193, _path194, _path195, _rect23, _g10, _path196, _path197, _g11, _path198, _mask7, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _rect24, _path209, _path210, _path211, _path212, _ellipse, _g12, _path213, _ellipse2, _rect25, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _mask8, _path239, _path240, _rect26, _path241, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 127,
    viewBox: "0 0 209 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1133_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 6.89543 0.895431 6 2 6H196.054C197.158 6 198.054 6.89543 198.054 8V104.143H0V8Z",
    fill: "url(#paint0_radial_1133_595)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.165 8C0.165 6.98656 0.986557 6.165 2 6.165H196.054C197.067 6.165 197.889 6.98656 197.889 8V103.978H0.165V8Z",
    stroke: "#455E52",
    strokeWidth: 0.330001
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1133_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.333 2C44.333 0.895432 45.2284 0 46.333 0H202.054C203.158 0 204.054 0.895431 204.054 2V93.1392C204.054 94.2438 203.158 95.1392 202.054 95.1392H46.333C45.2284 95.1392 44.333 94.2438 44.333 93.1392V2Z",
    fill: "url(#paint1_radial_1133_595)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.333 6L38.333 101.139",
    stroke: "#455E52",
    strokeWidth: 0.330001
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.165 101.304H197.889V124.611C197.889 125.625 197.067 126.446 196.054 126.446H2C0.986558 126.446 0.165 125.625 0.165 124.611V101.304Z",
    fill: "#293831",
    stroke: "#455E52",
    strokeWidth: 0.330001
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5809 117.868C97.7862 117.868 99.5739 116.081 99.5739 113.875C99.5739 111.67 97.7862 109.882 95.5809 109.882C93.3756 109.882 91.5879 111.67 91.5879 113.875C91.5879 116.081 93.3756 117.868 95.5809 117.868Z",
    stroke: "#455E52",
    strokeWidth: 0.660001
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76.7549,
    y: 26.8992,
    width: 6.76069,
    height: 23.9456,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5016 29.0735C73.5016 27.8205 74.5173 26.8047 75.7703 26.8047H78.1826C79.4356 26.8047 80.4513 27.8205 80.4513 29.0735V50.1812H73.5016V29.0735Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 28.8265C74.2909 28.4251 74.6163 28.0997 75.0177 28.0997C75.4191 28.0997 75.7445 28.4251 75.7445 28.8265V30.1851H74.2909V28.8265Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 32.2382C74.2909 31.8368 74.6163 31.5114 75.0177 31.5114C75.4191 31.5114 75.7445 31.8368 75.7445 32.2382V33.5968H74.2909V32.2382Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 35.6499C74.2909 35.2485 74.6163 34.9231 75.0177 34.9231C75.4191 34.9231 75.7445 35.2485 75.7445 35.6499V37.0085H74.2909V35.6499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 39.0616C74.2909 38.6602 74.6163 38.3348 75.0177 38.3348C75.4191 38.3348 75.7445 38.6602 75.7445 39.0616V40.4202H74.2909V39.0616Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 42.4733C74.2909 42.0719 74.6163 41.7465 75.0177 41.7465C75.4191 41.7465 75.7445 42.0719 75.7445 42.4733V43.8319H74.2909V42.4733Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 45.885C74.2909 45.4836 74.6163 45.1582 75.0177 45.1582C75.4191 45.1582 75.7445 45.4836 75.7445 45.885V47.2436H74.2909V45.885Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 28.8265C76.2494 28.4251 76.5748 28.0997 76.9762 28.0997C77.3776 28.0997 77.703 28.4251 77.703 28.8265V30.1851H76.2494V28.8265Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 32.2382C76.2494 31.8368 76.5748 31.5114 76.9762 31.5114C77.3776 31.5114 77.703 31.8368 77.703 32.2382V33.5968H76.2494V32.2382Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 35.6499C76.2494 35.2485 76.5748 34.9231 76.9762 34.9231C77.3776 34.9231 77.703 35.2485 77.703 35.6499V37.0085H76.2494V35.6499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 39.0616C76.2494 38.6602 76.5748 38.3348 76.9762 38.3348C77.3776 38.3348 77.703 38.6602 77.703 39.0616V40.4202H76.2494V39.0616Z",
    fill: "#86D383",
    stroke: "#4F7C56",
    strokeWidth: 0.189062
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 42.4733C76.2494 42.0719 76.5748 41.7465 76.9762 41.7465C77.3776 41.7465 77.703 42.0719 77.703 42.4733V43.8319H76.2494V42.4733Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 45.885C76.2494 45.4836 76.5748 45.1582 76.9762 45.1582C77.3776 45.1582 77.703 45.4836 77.703 45.885V47.2436H76.2494V45.885Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 28.8265C78.2078 28.4251 78.5332 28.0997 78.9346 28.0997C79.336 28.0997 79.6614 28.4251 79.6614 28.8265V30.1851H78.2078V28.8265Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 28.8265C81.3034 28.4251 81.6288 28.0997 82.0302 28.0997C82.4316 28.0997 82.757 28.4251 82.757 28.8265V30.1851H81.3034V28.8265Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 32.2382C81.3034 31.8368 81.6288 31.5114 82.0302 31.5114C82.4316 31.5114 82.757 31.8368 82.757 32.2382V33.5968H81.3034V32.2382Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 35.6499C81.3034 35.2485 81.6288 34.9231 82.0302 34.9231C82.4316 34.9231 82.757 35.2485 82.757 35.6499V37.0085H81.3034V35.6499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 39.0616C81.3034 38.6602 81.6288 38.3348 82.0302 38.3348C82.4316 38.3348 82.757 38.6602 82.757 39.0616V40.4202H81.3034V39.0616Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 42.4733C81.3034 42.0719 81.6288 41.7465 82.0302 41.7465C82.4316 41.7465 82.757 42.0719 82.757 42.4733V43.8319H81.3034V42.4733Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 45.885C81.3034 45.4836 81.6288 45.1582 82.0302 45.1582C82.4316 45.1582 82.757 45.4836 82.757 45.885V47.2436H81.3034V45.885Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 32.2382C78.2078 31.8368 78.5332 31.5114 78.9346 31.5114C79.336 31.5114 79.6614 31.8368 79.6614 32.2382V33.5968H78.2078V32.2382Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 35.6499C78.2078 35.2485 78.5332 34.9231 78.9346 34.9231C79.336 34.9231 79.6614 35.2485 79.6614 35.6499V37.0085H78.2078V35.6499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 39.0616C78.2078 38.6602 78.5332 38.3348 78.9346 38.3348C79.336 38.3348 79.6614 38.6602 79.6614 39.0616V40.4202H78.2078V39.0616Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 42.4733C78.2078 42.0719 78.5332 41.7465 78.9346 41.7465C79.336 41.7465 79.6614 42.0719 79.6614 42.4733V43.8319H78.2078V42.4733Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 45.885C78.2078 45.4836 78.5332 45.1582 78.9346 45.1582C79.336 45.1582 79.6614 45.4836 79.6614 45.885V47.2436H78.2078V45.885Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-1_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1549 39.0616C76.1549 38.608 76.5226 38.2402 76.9762 38.2402C77.4299 38.2402 77.7976 38.608 77.7976 39.0616V40.5147H76.1549V39.0616Z"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1549 39.0616C76.1549 38.608 76.5226 38.2402 76.9762 38.2402C77.4299 38.2402 77.7976 38.608 77.7976 39.0616V40.5147H76.1549V39.0616Z",
    fill: "#597364"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7976 40.5147V40.7038H77.9866V40.5147H77.7976ZM76.1549 40.5147H75.9658V40.7038H76.1549V40.5147ZM77.6085 39.0616V40.5147H77.9866V39.0616H77.6085ZM77.7976 40.3256H76.1549V40.7038H77.7976V40.3256ZM76.344 40.5147V39.0616H75.9658V40.5147H76.344ZM76.9762 38.4293C77.3254 38.4293 77.6085 38.7124 77.6085 39.0616H77.9866C77.9866 38.5035 77.5343 38.0512 76.9762 38.0512V38.4293ZM76.9762 38.0512C76.4182 38.0512 75.9658 38.5035 75.9658 39.0616H76.344C76.344 38.7124 76.627 38.4293 76.9762 38.4293V38.0512Z",
    fill: "#161E1A",
    mask: "url(#path-33-inside-1_1133_595)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.016,
    y: 50.1494,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.7549,
    y: 26.8992,
    width: 6.76069,
    height: 23.9456,
    rx: 2.17422,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5016 29.0735C73.5016 27.8205 74.5173 26.8047 75.7703 26.8047H78.1826C79.4356 26.8047 80.4513 27.8205 80.4513 29.0735V50.1812H73.5016V29.0735Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 28.8265C74.2909 28.4251 74.6163 28.0997 75.0177 28.0997C75.4191 28.0997 75.7445 28.4251 75.7445 28.8265V30.1851H74.2909V28.8265Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 32.2382C74.2909 31.8368 74.6163 31.5114 75.0177 31.5114C75.4191 31.5114 75.7445 31.8368 75.7445 32.2382V33.5968H74.2909V32.2382Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 35.6499C74.2909 35.2485 74.6163 34.9231 75.0177 34.9231C75.4191 34.9231 75.7445 35.2485 75.7445 35.6499V37.0085H74.2909V35.6499Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 39.0616C74.2909 38.6602 74.6163 38.3348 75.0177 38.3348C75.4191 38.3348 75.7445 38.6602 75.7445 39.0616V40.4202H74.2909V39.0616Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 42.4733C74.2909 42.0719 74.6163 41.7465 75.0177 41.7465C75.4191 41.7465 75.7445 42.0719 75.7445 42.4733V43.8319H74.2909V42.4733Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2909 45.885C74.2909 45.4836 74.6163 45.1582 75.0177 45.1582C75.4191 45.1582 75.7445 45.4836 75.7445 45.885V47.2436H74.2909V45.885Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 28.8265C76.2494 28.4251 76.5748 28.0997 76.9762 28.0997C77.3776 28.0997 77.703 28.4251 77.703 28.8265V30.1851H76.2494V28.8265Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 32.2382C76.2494 31.8368 76.5748 31.5114 76.9762 31.5114C77.3776 31.5114 77.703 31.8368 77.703 32.2382V33.5968H76.2494V32.2382Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 35.6499C76.2494 35.2485 76.5748 34.9231 76.9762 34.9231C77.3776 34.9231 77.703 35.2485 77.703 35.6499V37.0085H76.2494V35.6499Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 39.0616C76.2494 38.6602 76.5748 38.3348 76.9762 38.3348C77.3776 38.3348 77.703 38.6602 77.703 39.0616V40.4202H76.2494V39.0616Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 42.4733C76.2494 42.0719 76.5748 41.7465 76.9762 41.7465C77.3776 41.7465 77.703 42.0719 77.703 42.4733V43.8319H76.2494V42.4733Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2494 45.885C76.2494 45.4836 76.5748 45.1582 76.9762 45.1582C77.3776 45.1582 77.703 45.4836 77.703 45.885V47.2436H76.2494V45.885Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 28.8265C78.2078 28.4251 78.5332 28.0997 78.9346 28.0997C79.336 28.0997 79.6614 28.4251 79.6614 28.8265V30.1851H78.2078V28.8265Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 28.8265C81.3034 28.4251 81.6288 28.0997 82.0302 28.0997C82.4316 28.0997 82.757 28.4251 82.757 28.8265V30.1851H81.3034V28.8265Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 32.2382C81.3034 31.8368 81.6288 31.5114 82.0302 31.5114C82.4316 31.5114 82.757 31.8368 82.757 32.2382V33.5968H81.3034V32.2382Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 35.6499C81.3034 35.2485 81.6288 34.9231 82.0302 34.9231C82.4316 34.9231 82.757 35.2485 82.757 35.6499V37.0085H81.3034V35.6499Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 39.0616C81.3034 38.6602 81.6288 38.3348 82.0302 38.3348C82.4316 38.3348 82.757 38.6602 82.757 39.0616V40.4202H81.3034V39.0616Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 42.4733C81.3034 42.0719 81.6288 41.7465 82.0302 41.7465C82.4316 41.7465 82.757 42.0719 82.757 42.4733V43.8319H81.3034V42.4733Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3034 45.885C81.3034 45.4836 81.6288 45.1582 82.0302 45.1582C82.4316 45.1582 82.757 45.4836 82.757 45.885V47.2436H81.3034V45.885Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 32.2382C78.2078 31.8368 78.5332 31.5114 78.9346 31.5114C79.336 31.5114 79.6614 31.8368 79.6614 32.2382V33.5968H78.2078V32.2382Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 35.6499C78.2078 35.2485 78.5332 34.9231 78.9346 34.9231C79.336 34.9231 79.6614 35.2485 79.6614 35.6499V37.0085H78.2078V35.6499Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 39.0616C78.2078 38.6602 78.5332 38.3348 78.9346 38.3348C79.336 38.3348 79.6614 38.6602 79.6614 39.0616V40.4202H78.2078V39.0616Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 42.4733C78.2078 42.0719 78.5332 41.7465 78.9346 41.7465C79.336 41.7465 79.6614 42.0719 79.6614 42.4733V43.8319H78.2078V42.4733Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2078 45.885C78.2078 45.4836 78.5332 45.1582 78.9346 45.1582C79.336 45.1582 79.6614 45.4836 79.6614 45.885V47.2436H78.2078V45.885Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-62-inside-2_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.1549 39.0616C76.1549 38.608 76.5226 38.2402 76.9762 38.2402C77.4299 38.2402 77.7976 38.608 77.7976 39.0616V40.5147H76.1549V39.0616Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.1549 39.0616C76.1549 38.608 76.5226 38.2402 76.9762 38.2402C77.4299 38.2402 77.7976 38.608 77.7976 39.0616V40.5147H76.1549V39.0616Z",
    fill: "#0B100E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7976 40.5147V40.7038H77.9866V40.5147H77.7976ZM76.1549 40.5147H75.9658V40.7038H76.1549V40.5147ZM77.6085 39.0616V40.5147H77.9866V39.0616H77.6085ZM77.7976 40.3256H76.1549V40.7038H77.7976V40.3256ZM76.344 40.5147V39.0616H75.9658V40.5147H76.344ZM76.9762 38.4293C77.3254 38.4293 77.6085 38.7124 77.6085 39.0616H77.9866C77.9866 38.5035 77.5343 38.0512 76.9762 38.0512V38.4293ZM76.9762 38.0512C76.4182 38.0512 75.9658 38.5035 75.9658 39.0616H76.344C76.344 38.7124 76.627 38.4293 76.9762 38.4293V38.0512Z",
    fill: "#0B100E",
    mask: "url(#path-62-inside-2_1133_595)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.016,
    y: 50.1494,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127.245,
    y: 29.1738,
    width: 4.8653,
    height: 21.6711,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122.097 30.3391C122.097 29.5752 122.481 28.8626 123.12 28.443L127.151 25.7939V50.1813H122.097V30.3391Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.822 32.1732C122.822 31.8077 123.119 31.5114 123.484 31.5114H123.614C123.98 31.5114 124.276 31.8077 124.276 32.1731V33.5968H122.822V32.1732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.822 35.5849C122.822 35.2194 123.119 34.9231 123.484 34.9231H123.614C123.98 34.9231 124.276 35.2194 124.276 35.5849V37.0086H122.822V35.5849Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M122.822 38.9966C122.822 38.6311 123.119 38.3349 123.484 38.3349H123.614C123.98 38.3349 124.276 38.6311 124.276 38.9966V40.4203H122.822V38.9966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M122.822 42.4083C122.822 42.0428 123.119 41.7466 123.484 41.7466H123.614C123.98 41.7466 124.276 42.0428 124.276 42.4083V43.832H122.822V42.4083Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M122.822 45.82C122.822 45.4545 123.119 45.1583 123.484 45.1583H123.614C123.98 45.1583 124.276 45.4545 124.276 45.82V47.2437H122.822V45.82Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M127.877 32.1732C127.877 31.8077 128.173 31.5114 128.538 31.5114H128.668C129.034 31.5114 129.33 31.8077 129.33 32.1731V33.5968H127.877V32.1732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M127.877 35.5849C127.877 35.2194 128.173 34.9231 128.538 34.9231H128.668C129.034 34.9231 129.33 35.2194 129.33 35.5849V37.0086H127.877V35.5849Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.877 38.9966C127.877 38.6311 128.173 38.3349 128.538 38.3349H128.668C129.034 38.3349 129.33 38.6311 129.33 38.9966V40.4203H127.877V38.9966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M127.877 42.4083C127.877 42.0428 128.173 41.7466 128.538 41.7466H128.668C129.034 41.7466 129.33 42.0428 129.33 42.4083V43.832H127.877V42.4083Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M127.877 45.82C127.877 45.4545 128.173 45.1583 128.538 45.1583H128.668C129.034 45.1583 129.33 45.4545 129.33 45.82V47.2437H127.877V45.82Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M124.97 32.1732C124.97 31.8078 125.266 31.5115 125.632 31.5115H125.762C126.127 31.5115 126.424 31.8078 126.424 32.1732V33.5969H124.97V32.1732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M124.97 35.5849C124.97 35.2195 125.266 34.9232 125.632 34.9232H125.762C126.127 34.9232 126.424 35.2195 126.424 35.5849V37.0086H124.97V35.5849Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M124.97 38.9966C124.97 38.6311 125.266 38.3349 125.632 38.3349H125.762C126.127 38.3349 126.424 38.6311 126.424 38.9966V40.4203H124.97V38.9966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M124.97 42.4083C124.97 42.0429 125.266 41.7466 125.632 41.7466H125.762C126.127 41.7466 126.424 42.0429 126.424 42.4083V43.832H124.97V42.4083Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M124.97 45.82C124.97 45.4546 125.266 45.1583 125.632 45.1583H125.762C126.127 45.1583 126.424 45.4546 126.424 45.82V47.2437H124.97V45.82Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.025 32.1732C130.025 31.8077 130.321 31.5114 130.687 31.5114H130.817C131.182 31.5114 131.479 31.8077 131.479 32.1732V33.5969H130.025V32.1732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M130.025 35.5849C130.025 35.2194 130.321 34.9231 130.687 34.9231H130.817C131.182 34.9231 131.479 35.2194 131.479 35.5849V37.0086H130.025V35.5849Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M130.025 38.9966C130.025 38.6311 130.321 38.3349 130.687 38.3349H130.817C131.182 38.3349 131.479 38.6311 131.479 38.9966V40.4203H130.025V38.9966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.025 42.4083C130.025 42.0428 130.321 41.7466 130.687 41.7466H130.817C131.182 41.7466 131.479 42.0428 131.479 42.4083V43.832H130.025V42.4083Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M130.025 45.82C130.025 45.4545 130.321 45.1583 130.687 45.1583H130.817C131.182 45.1583 131.479 45.4545 131.479 45.82V47.2437H130.025V45.82Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.611,
    y: 50.1495,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.245,
    y: 29.1738,
    width: 4.8653,
    height: 21.6711,
    rx: 2.17422,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.097 30.3391C122.097 29.5752 122.481 28.8626 123.12 28.443L127.151 25.7939V50.1813H122.097V30.3391Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.822 32.1732C122.822 31.8077 123.119 31.5114 123.484 31.5114H123.614C123.98 31.5114 124.276 31.8077 124.276 32.1731V33.5968H122.822V32.1732Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.822 35.5849C122.822 35.2194 123.119 34.9231 123.484 34.9231H123.614C123.98 34.9231 124.276 35.2194 124.276 35.5849V37.0086H122.822V35.5849Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.822 38.9966C122.822 38.6311 123.119 38.3349 123.484 38.3349H123.614C123.98 38.3349 124.276 38.6311 124.276 38.9966V40.4203H122.822V38.9966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.822 42.4083C122.822 42.0428 123.119 41.7466 123.484 41.7466H123.614C123.98 41.7466 124.276 42.0428 124.276 42.4083V43.832H122.822V42.4083Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.822 45.82C122.822 45.4545 123.119 45.1583 123.484 45.1583H123.614C123.98 45.1583 124.276 45.4545 124.276 45.82V47.2437H122.822V45.82Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.877 32.1732C127.877 31.8077 128.173 31.5114 128.538 31.5114H128.668C129.034 31.5114 129.33 31.8077 129.33 32.1731V33.5968H127.877V32.1732Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.877 35.5849C127.877 35.2194 128.173 34.9231 128.538 34.9231H128.668C129.034 34.9231 129.33 35.2194 129.33 35.5849V37.0086H127.877V35.5849Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.877 38.9966C127.877 38.6311 128.173 38.3349 128.538 38.3349H128.668C129.034 38.3349 129.33 38.6311 129.33 38.9966V40.4203H127.877V38.9966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.877 42.4083C127.877 42.0428 128.173 41.7466 128.538 41.7466H128.668C129.034 41.7466 129.33 42.0428 129.33 42.4083V43.832H127.877V42.4083Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.877 45.82C127.877 45.4545 128.173 45.1583 128.538 45.1583H128.668C129.034 45.1583 129.33 45.4545 129.33 45.82V47.2437H127.877V45.82Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.97 32.1732C124.97 31.8078 125.266 31.5115 125.632 31.5115H125.762C126.127 31.5115 126.424 31.8078 126.424 32.1732V33.5969H124.97V32.1732Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.97 35.5849C124.97 35.2195 125.266 34.9232 125.632 34.9232H125.762C126.127 34.9232 126.424 35.2195 126.424 35.5849V37.0086H124.97V35.5849Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.97 38.9966C124.97 38.6311 125.266 38.3349 125.632 38.3349H125.762C126.127 38.3349 126.424 38.6311 126.424 38.9966V40.4203H124.97V38.9966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.97 42.4083C124.97 42.0429 125.266 41.7466 125.632 41.7466H125.762C126.127 41.7466 126.424 42.0429 126.424 42.4083V43.832H124.97V42.4083Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.97 45.82C124.97 45.4546 125.266 45.1583 125.632 45.1583H125.762C126.127 45.1583 126.424 45.4546 126.424 45.82V47.2437H124.97V45.82Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.025 32.1732C130.025 31.8077 130.321 31.5114 130.687 31.5114H130.817C131.182 31.5114 131.479 31.8077 131.479 32.1732V33.5969H130.025V32.1732Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.025 35.5849C130.025 35.2194 130.321 34.9231 130.687 34.9231H130.817C131.182 34.9231 131.479 35.2194 131.479 35.5849V37.0086H130.025V35.5849Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.025 38.9966C130.025 38.6311 130.321 38.3349 130.687 38.3349H130.817C131.182 38.3349 131.479 38.6311 131.479 38.9966V40.4203H130.025V38.9966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.025 42.4083C130.025 42.0428 130.321 41.7466 130.687 41.7466H130.817C131.182 41.7466 131.479 42.0428 131.479 42.4083V43.832H130.025V42.4083Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.025 45.82C130.025 45.4545 130.321 45.1583 130.687 45.1583H130.817C131.182 45.1583 131.479 45.4545 131.479 45.82V47.2437H130.025V45.82Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.611,
    y: 50.1495,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-3_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.151 34.6393H98.1189V37.8382L97.7971 38.191C97.6383 38.3651 97.5503 38.5923 97.5503 38.828V39.5673H104.008C104.419 39.5673 104.753 39.2338 104.753 38.8224C104.753 38.5903 104.666 38.3666 104.51 38.1951L101.71 35.1256C101.56 34.9612 101.356 34.8789 101.151 34.8789V34.6393Z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.151 34.6393H98.1189V37.8382L97.7971 38.191C97.6383 38.3651 97.5503 38.5923 97.5503 38.828V39.5673H104.008C104.419 39.5673 104.753 39.2338 104.753 38.8224C104.753 38.5903 104.666 38.3666 104.51 38.1951L101.71 35.1256C101.56 34.9612 101.356 34.8789 101.151 34.8789V34.6393Z",
    fill: "#678D7C"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1189 34.6393V34.4502H97.9298V34.6393H98.1189ZM101.151 34.6393H101.341V34.4502H101.151V34.6393ZM98.1189 37.8382L98.2586 37.9656L98.3079 37.9115V37.8382H98.1189ZM97.7971 38.191L97.6574 38.0636H97.6574L97.7971 38.191ZM97.5503 39.5673H97.3612V39.7564H97.5503V39.5673ZM104.51 38.1951L104.37 38.3225L104.51 38.1951ZM101.71 35.1256L101.85 34.9982V34.9982L101.71 35.1256ZM101.151 34.8789H100.962V35.068L101.151 35.068L101.151 34.8789ZM98.1189 34.8283H101.151V34.4502H98.1189V34.8283ZM98.3079 37.8382V34.6393H97.9298V37.8382H98.3079ZM97.9368 38.3184L98.2586 37.9656L97.9792 37.7108L97.6574 38.0636L97.9368 38.3184ZM97.7394 38.828C97.7394 38.6394 97.8098 38.4577 97.9368 38.3184L97.6574 38.0636C97.4669 38.2725 97.3612 38.5452 97.3612 38.828H97.7394ZM97.7394 39.5673V38.828H97.3612V39.5673H97.7394ZM104.008 39.3782H97.5503V39.7564H104.008V39.3782ZM104.564 38.8224C104.564 39.1294 104.315 39.3782 104.008 39.3782V39.7564C104.524 39.7564 104.942 39.3382 104.942 38.8224H104.564ZM104.37 38.3225C104.495 38.4591 104.564 38.6375 104.564 38.8224H104.942C104.942 38.5432 104.838 38.274 104.649 38.0677L104.37 38.3225ZM101.571 35.253L104.37 38.3225L104.649 38.0677L101.85 34.9982L101.571 35.253ZM101.151 35.068C101.305 35.068 101.458 35.1296 101.571 35.253L101.85 34.9982C101.663 34.7927 101.407 34.6899 101.151 34.6899L101.151 35.068ZM100.962 34.6393V34.8789H101.341V34.6393H100.962Z",
    fill: "#161E1A",
    mask: "url(#path-111-inside-3_1133_595)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8971 42.3415C97.8971 41.1407 98.8706 40.1673 100.071 40.1673H102.484C103.684 40.1673 104.658 41.1407 104.658 42.3415V48.355C104.658 49.5558 103.684 50.5292 102.484 50.5292H100.071C98.8706 50.5292 97.8971 49.5558 97.8971 48.355V42.3415Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6437 40.829C94.6437 40.4113 94.9823 40.0727 95.3999 40.0727H100.837C101.255 40.0727 101.593 40.4113 101.593 40.829V50.1815H94.6437V40.829Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M95.433 45.8202C95.433 45.4547 95.7293 45.1585 96.0947 45.1585H98.1835C98.5489 45.1585 98.8452 45.4547 98.8452 45.8202V47.2439H95.433V45.8202Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M95.433 42.4084C95.433 42.043 95.7293 41.7467 96.0947 41.7467H98.1835C98.5489 41.7467 98.8452 42.043 98.8452 42.4084V43.8321H95.433V42.4084Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3509 42.4085C99.3509 42.043 99.6471 41.7468 100.013 41.7468H100.143C100.508 41.7468 100.804 42.043 100.804 42.4085V43.8322H99.3509V42.4085Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M102.446 42.4084C102.446 42.043 102.743 41.7467 103.108 41.7467H103.238C103.604 41.7467 103.9 42.043 103.9 42.4084V43.8321H102.446V42.4084Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M102.446 45.8201C102.446 45.4547 102.743 45.1584 103.108 45.1584H103.238C103.604 45.1584 103.9 45.4547 103.9 45.8201V47.2438H102.446V45.8201Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3501 45.8202C99.3501 45.4547 99.6464 45.1585 100.012 45.1585H100.142C100.507 45.1585 100.804 45.4547 100.804 45.8202V47.2439H99.3501V45.8202Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.1586,
    y: 50.1496,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1708 34.9552C97.1708 34.8156 97.0576 34.7024 96.9181 34.7024C96.7785 34.7024 96.6653 34.8156 96.6653 34.9552V37.1033C96.6653 37.2428 96.7785 37.356 96.9181 37.356C97.0576 37.356 97.1708 37.2428 97.1708 37.1033V34.9552Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1599 35.966C96.1599 35.8265 96.0468 35.7133 95.9072 35.7133C95.7676 35.7133 95.6545 35.8265 95.6545 35.966V37.7351C95.6545 37.8746 95.7676 37.9878 95.9072 37.9878C96.0468 37.9878 96.1599 37.8746 96.1599 37.7351V35.966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8778 38.1956L97.5508 35.158C97.852 34.8158 98.3851 34.8158 98.6863 35.158L101.359 38.1956C101.51 38.367 101.593 38.5876 101.593 38.816C101.593 39.2309 101.257 39.5673 100.842 39.5673H95.395C94.98 39.5673 94.6437 39.2309 94.6437 38.816C94.6437 38.5876 94.7269 38.367 94.8778 38.1956Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-125-inside-4_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.151 34.6393H98.1189V37.8382L97.7971 38.191C97.6383 38.3651 97.5503 38.5923 97.5503 38.828V39.5673H104.008C104.419 39.5673 104.753 39.2338 104.753 38.8224C104.753 38.5903 104.666 38.3666 104.51 38.1951L101.71 35.1256C101.56 34.9612 101.356 34.8789 101.151 34.8789V34.6393Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.151 34.6393H98.1189V37.8382L97.7971 38.191C97.6383 38.3651 97.5503 38.5923 97.5503 38.828V39.5673H104.008C104.419 39.5673 104.753 39.2338 104.753 38.8224C104.753 38.5903 104.666 38.3666 104.51 38.1951L101.71 35.1256C101.56 34.9612 101.356 34.8789 101.151 34.8789V34.6393Z",
    fill: "#0B100E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1189 34.6393V34.4502H97.9298V34.6393H98.1189ZM101.151 34.6393H101.341V34.4502H101.151V34.6393ZM98.1189 37.8382L98.2586 37.9656L98.3079 37.9115V37.8382H98.1189ZM97.7971 38.191L97.6574 38.0636H97.6574L97.7971 38.191ZM97.5503 39.5673H97.3612V39.7564H97.5503V39.5673ZM104.51 38.1951L104.37 38.3225L104.51 38.1951ZM101.71 35.1256L101.85 34.9982V34.9982L101.71 35.1256ZM101.151 34.8789H100.962V35.068L101.151 35.068L101.151 34.8789ZM98.1189 34.8283H101.151V34.4502H98.1189V34.8283ZM98.3079 37.8382V34.6393H97.9298V37.8382H98.3079ZM97.9368 38.3184L98.2586 37.9656L97.9792 37.7108L97.6574 38.0636L97.9368 38.3184ZM97.7394 38.828C97.7394 38.6394 97.8098 38.4577 97.9368 38.3184L97.6574 38.0636C97.4669 38.2725 97.3612 38.5452 97.3612 38.828H97.7394ZM97.7394 39.5673V38.828H97.3612V39.5673H97.7394ZM104.008 39.3782H97.5503V39.7564H104.008V39.3782ZM104.564 38.8224C104.564 39.1294 104.315 39.3782 104.008 39.3782V39.7564C104.524 39.7564 104.942 39.3382 104.942 38.8224H104.564ZM104.37 38.3225C104.495 38.4591 104.564 38.6375 104.564 38.8224H104.942C104.942 38.5432 104.838 38.274 104.649 38.0677L104.37 38.3225ZM101.571 35.253L104.37 38.3225L104.649 38.0677L101.85 34.9982L101.571 35.253ZM101.151 35.068C101.305 35.068 101.458 35.1296 101.571 35.253L101.85 34.9982C101.663 34.7927 101.407 34.6899 101.151 34.6899L101.151 35.068ZM100.962 34.6393V34.8789H101.341V34.6393H100.962Z",
    fill: "#0B100E",
    mask: "url(#path-125-inside-4_1133_595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8971 42.3415C97.8971 41.1407 98.8706 40.1673 100.071 40.1673H102.484C103.684 40.1673 104.658 41.1407 104.658 42.3415V48.355C104.658 49.5558 103.684 50.5292 102.484 50.5292H100.071C98.8706 50.5292 97.8971 49.5558 97.8971 48.355V42.3415Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6437 40.829C94.6437 40.4113 94.9823 40.0727 95.3999 40.0727H100.837C101.255 40.0727 101.593 40.4113 101.593 40.829V50.1815H94.6437V40.829Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.433 45.8202C95.433 45.4547 95.7293 45.1585 96.0947 45.1585H98.1835C98.5489 45.1585 98.8452 45.4547 98.8452 45.8202V47.2439H95.433V45.8202Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.433 42.4084C95.433 42.043 95.7293 41.7467 96.0947 41.7467H98.1835C98.5489 41.7467 98.8452 42.043 98.8452 42.4084V43.8321H95.433V42.4084Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3509 42.4085C99.3509 42.043 99.6471 41.7468 100.013 41.7468H100.143C100.508 41.7468 100.804 42.043 100.804 42.4085V43.8322H99.3509V42.4085Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.446 42.4084C102.446 42.043 102.743 41.7467 103.108 41.7467H103.238C103.604 41.7467 103.9 42.043 103.9 42.4084V43.8321H102.446V42.4084Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.446 45.8201C102.446 45.4547 102.743 45.1584 103.108 45.1584H103.238C103.604 45.1584 103.9 45.4547 103.9 45.8201V47.2438H102.446V45.8201Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3501 45.8202C99.3501 45.4547 99.6464 45.1585 100.012 45.1585H100.142C100.507 45.1585 100.804 45.4547 100.804 45.8202V47.2439H99.3501V45.8202Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.1586,
    y: 50.1496,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1708 34.9552C97.1708 34.8156 97.0576 34.7024 96.9181 34.7024C96.7785 34.7024 96.6653 34.8156 96.6653 34.9552V37.1033C96.6653 37.2428 96.7785 37.356 96.9181 37.356C97.0576 37.356 97.1708 37.2428 97.1708 37.1033V34.9552Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1599 35.966C96.1599 35.8265 96.0468 35.7133 95.9072 35.7133C95.7676 35.7133 95.6545 35.8265 95.6545 35.966V37.7351C95.6545 37.8746 95.7676 37.9878 95.9072 37.9878C96.0468 37.9878 96.1599 37.8746 96.1599 37.7351V35.966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8778 38.1956L97.5508 35.158C97.852 34.8158 98.3851 34.8158 98.6863 35.158L101.359 38.1956C101.51 38.367 101.593 38.5876 101.593 38.816C101.593 39.2309 101.257 39.5673 100.842 39.5673H95.395C94.98 39.5673 94.6437 39.2309 94.6437 38.816C94.6437 38.5876 94.7269 38.367 94.8778 38.1956Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 167.246,
    y: 35.7445,
    width: 6.76069,
    height: 15.1004,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M163.992 37.9187C163.992 36.6657 165.008 35.65 166.261 35.65H168.673C169.926 35.65 170.942 36.6657 170.942 37.9187V50.1813H163.992V37.9187Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M164.785 47.2437C164.834 46.0862 165.788 45.1583 166.957 45.1583H167.533C167.899 45.1583 168.195 45.4546 168.195 45.82V47.2437H164.785Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M166.743 40.4203C166.793 39.2628 167.746 38.3349 168.915 38.3349H169.491C169.857 38.3349 170.153 38.6312 170.153 38.9966V40.4203H166.743Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M164.786 43.832C164.835 42.6745 165.789 41.7466 166.958 41.7466H167.534C167.899 41.7466 168.196 42.0429 168.196 42.4083V43.832H164.786Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M168.7 42.4083C168.7 42.0429 168.996 41.7466 169.362 41.7466H169.492C169.857 41.7466 170.154 42.0429 170.154 42.4083V43.832H168.7V42.4083Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M171.796 38.9966C171.796 38.6312 172.093 38.3349 172.458 38.3349H172.588C172.954 38.3349 173.25 38.6312 173.25 38.9966V40.4203H171.796V38.9966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M171.796 42.4083C171.796 42.0429 172.093 41.7466 172.458 41.7466H172.588C172.954 41.7466 173.25 42.0429 173.25 42.4083V43.832H171.796V42.4083Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M171.796 45.8201C171.796 45.4546 172.093 45.1583 172.458 45.1583H172.588C172.954 45.1583 173.25 45.4546 173.25 45.8201V47.2438H171.796V45.8201Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M168.701 45.82C168.701 45.4546 168.997 45.1583 169.362 45.1583H169.492C169.858 45.1583 170.154 45.4546 170.154 45.82V47.2437H168.701V45.82Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M164.783 38.9966C164.783 38.6311 165.079 38.3349 165.444 38.3349H165.575C165.94 38.3349 166.236 38.6311 166.236 38.9966V40.4203H164.783V38.9966Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 162.508,
    y: 50.1495,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.246,
    y: 35.7445,
    width: 6.76069,
    height: 15.1004,
    rx: 2.17422,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.992 37.9187C163.992 36.6657 165.008 35.65 166.261 35.65H168.673C169.926 35.65 170.942 36.6657 170.942 37.9187V50.1813H163.992V37.9187Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.785 47.2437C164.834 46.0862 165.788 45.1583 166.957 45.1583H167.533C167.899 45.1583 168.195 45.4546 168.195 45.82V47.2437H164.785Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.743 40.4203C166.793 39.2628 167.746 38.3349 168.915 38.3349H169.491C169.857 38.3349 170.153 38.6312 170.153 38.9966V40.4203H166.743Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.786 43.832C164.835 42.6745 165.789 41.7466 166.958 41.7466H167.534C167.899 41.7466 168.196 42.0429 168.196 42.4083V43.832H164.786Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7 42.4083C168.7 42.0429 168.996 41.7466 169.362 41.7466H169.492C169.857 41.7466 170.154 42.0429 170.154 42.4083V43.832H168.7V42.4083Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.796 38.9966C171.796 38.6312 172.093 38.3349 172.458 38.3349H172.588C172.954 38.3349 173.25 38.6312 173.25 38.9966V40.4203H171.796V38.9966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.796 42.4083C171.796 42.0429 172.093 41.7466 172.458 41.7466H172.588C172.954 41.7466 173.25 42.0429 173.25 42.4083V43.832H171.796V42.4083Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.796 45.8201C171.796 45.4546 172.093 45.1583 172.458 45.1583H172.588C172.954 45.1583 173.25 45.4546 173.25 45.8201V47.2438H171.796V45.8201Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.701 45.82C168.701 45.4546 168.997 45.1583 169.362 45.1583H169.492C169.858 45.1583 170.154 45.4546 170.154 45.82V47.2437H168.701V45.82Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.783 38.9966C164.783 38.6311 165.079 38.3349 165.444 38.3349H165.575C165.94 38.3349 166.236 38.6311 166.236 38.9966V40.4203H164.783V38.9966Z",
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.508,
    y: 50.1495,
    width: 13.0786,
    height: 1.07453,
    rx: 0.537266,
    fill: "#0B100E",
    stroke: "#0B100E",
    strokeWidth: 0.189062
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-163-inside-5_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6131 45.0264H88.7409V49.1109L88.2617 49.6363C88.1029 49.8105 88.0149 50.0376 88.0149 50.2733V51.3187H88.7409H92.6131H96.4551C96.8727 51.3187 97.2113 50.9801 97.2113 50.5625V50.2733C97.2113 50.0376 97.1233 49.8105 96.9645 49.6363L93.1719 45.4778C93.0219 45.3133 92.8175 45.2311 92.6131 45.2311V45.0264Z"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6131 45.0264H88.7409V49.1109L88.2617 49.6363C88.1029 49.8105 88.0149 50.0376 88.0149 50.2733V51.3187H88.7409H92.6131H96.4551C96.8727 51.3187 97.2113 50.9801 97.2113 50.5625V50.2733C97.2113 50.0376 97.1233 49.8105 96.9645 49.6363L93.1719 45.4778C93.0219 45.3133 92.8175 45.2311 92.6131 45.2311V45.0264Z",
    fill: "#678D7C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7409 45.0264V44.8374H88.5518V45.0264H88.7409ZM92.6131 45.0264H92.8021V44.8374H92.6131V45.0264ZM88.7409 49.1109L88.8806 49.2383L88.93 49.1842V49.1109H88.7409ZM88.2617 49.6363L88.4014 49.7637L88.4014 49.7637L88.2617 49.6363ZM88.0149 51.3187H87.8258V51.5078H88.0149V51.3187ZM96.9645 49.6363L97.1041 49.5089L96.9645 49.6363ZM93.1719 45.4778L93.0322 45.6052L93.0322 45.6052L93.1719 45.4778ZM92.6131 45.2311H92.424V45.4202L92.6131 45.4202L92.6131 45.2311ZM88.7409 45.2155H92.6131V44.8374H88.7409V45.2155ZM88.93 49.1109V45.0264H88.5518V49.1109H88.93ZM88.4014 49.7637L88.8806 49.2383L88.6012 48.9835L88.122 49.5089L88.4014 49.7637ZM88.204 50.2733C88.204 50.0848 88.2744 49.903 88.4014 49.7637L88.122 49.5089C87.9315 49.7179 87.8258 49.9905 87.8258 50.2733H88.204ZM88.204 51.3187V50.2733H87.8258V51.3187H88.204ZM88.7409 51.1297H88.0149V51.5078H88.7409V51.1297ZM92.6131 51.1297H88.7409V51.5078H92.6131V51.1297ZM96.4551 51.1297H92.6131V51.5078H96.4551V51.1297ZM97.0222 50.5625C97.0222 50.8757 96.7683 51.1297 96.4551 51.1297V51.5078C96.9771 51.5078 97.4004 51.0846 97.4004 50.5625H97.0222ZM97.0222 50.2733V50.5625H97.4004V50.2733H97.0222ZM96.8248 49.7637C96.9518 49.903 97.0222 50.0848 97.0222 50.2733H97.4004C97.4004 49.9905 97.2947 49.7179 97.1041 49.5089L96.8248 49.7637ZM93.0322 45.6052L96.8248 49.7637L97.1041 49.5089L93.3116 45.3504L93.0322 45.6052ZM92.6131 45.4202C92.7668 45.4202 92.9197 45.4818 93.0322 45.6052L93.3116 45.3504C93.1241 45.1449 92.8682 45.0421 92.6131 45.0421L92.6131 45.4202ZM92.424 45.0264V45.2311H92.8021V45.0264H92.424Z",
    fill: "#161E1A",
    mask: "url(#path-163-inside-5_1133_595)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M88.431 54.2329C88.431 53.0321 89.4044 52.0586 90.6052 52.0586H94.9414C96.1422 52.0586 97.1156 53.0321 97.1156 54.2329V63.1673C97.1156 64.3681 96.1422 65.3415 94.9414 65.3415H90.6052C89.4044 65.3415 88.431 64.3681 88.431 63.1673V54.2329Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3033 52.7204C84.3033 52.3027 84.6419 51.9641 85.0596 51.9641H92.4208C92.8385 51.9641 93.1771 52.3027 93.1771 52.7204V64.8714H84.3033V52.7204Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2853 59.0934C85.2853 58.7279 85.5816 58.4316 85.947 58.4316H89.0328C89.3982 58.4316 89.6945 58.7279 89.6945 59.0934V61.1467H85.2853V59.0934Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2853 54.7371C85.2853 54.3717 85.5816 54.0754 85.947 54.0754H89.0328C89.3982 54.0754 89.6945 54.3717 89.6945 54.7371V56.7905H85.2853V54.7371Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2859 54.7371C90.2859 54.3716 90.5822 54.0754 90.9477 54.0754H91.5326C91.898 54.0754 92.1943 54.3716 92.1943 54.7371V56.7905H90.2859V54.7371Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2391 54.7371C94.2391 54.3716 94.5353 54.0754 94.9008 54.0754H95.4857C95.8512 54.0754 96.1474 54.3716 96.1474 54.7371V56.7904H94.2391V54.7371Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2391 59.0933C94.2391 58.7278 94.5353 58.4316 94.9008 58.4316H95.4857C95.8512 58.4316 96.1474 58.7278 96.1474 59.0933V61.1467H94.2391V59.0933Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2859 59.0933C90.2859 58.7279 90.5822 58.4316 90.9477 58.4316H91.5326C91.898 58.4316 92.1943 58.7279 92.1943 59.0933V61.1467H90.2859V59.0933Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 82.381,
    y: 64.8045,
    width: 16.7517,
    height: 1.42435,
    rx: 0.712174,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M87.53 45.4298C87.53 45.2516 87.3856 45.1071 87.2073 45.1071C87.0291 45.1071 86.8847 45.2516 86.8847 45.4298V48.1726C86.8847 48.3508 87.0291 48.4952 87.2073 48.4952C87.3856 48.4952 87.53 48.3508 87.53 48.1726V45.4298Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2399 46.7205C86.2399 46.5423 86.0954 46.3978 85.9172 46.3978C85.739 46.3978 85.5945 46.5423 85.5945 46.7205V48.9793C85.5945 49.1575 85.739 49.302 85.9172 49.302C86.0954 49.302 86.2399 49.1575 86.2399 48.9793V46.7205Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M84.539 49.6392L88.1725 45.5102C88.4736 45.168 89.0068 45.168 89.3079 45.5102L92.9414 49.6392C93.0933 49.8118 93.1771 50.0338 93.1771 50.2637V50.5625C93.1771 50.9801 92.8385 51.3187 92.4208 51.3187H85.0596C84.6419 51.3187 84.3033 50.9801 84.3033 50.5625V50.2637C84.3033 50.0338 84.3871 49.8118 84.539 49.6392Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-177-inside-6_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6127 45.0264H88.7405V49.1114L88.2617 49.6363C88.1029 49.8105 88.0149 50.0376 88.0149 50.2733V51.3187H88.7405V51.3187H92.6127V51.3187H96.4551C96.8727 51.3187 97.2113 50.9801 97.2113 50.5625V50.2733C97.2113 50.0376 97.1233 49.8105 96.9645 49.6363L93.1719 45.4778C93.0218 45.3132 92.8172 45.231 92.6127 45.2311V45.0264Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6127 45.0264H88.7405V49.1114L88.2617 49.6363C88.1029 49.8105 88.0149 50.0376 88.0149 50.2733V51.3187H88.7405V51.3187H92.6127V51.3187H96.4551C96.8727 51.3187 97.2113 50.9801 97.2113 50.5625V50.2733C97.2113 50.0376 97.1233 49.8105 96.9645 49.6363L93.1719 45.4778C93.0218 45.3132 92.8172 45.231 92.6127 45.2311V45.0264Z",
    fill: "#161E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7405 45.0264V44.8374H88.5515V45.0264H88.7405ZM92.6127 45.0264H92.8017V44.8374H92.6127V45.0264ZM88.7405 49.1114L88.8802 49.2388L88.9296 49.1846V49.1114H88.7405ZM88.2617 49.6363L88.4014 49.7637L88.4014 49.7637L88.2617 49.6363ZM88.0149 51.3187H87.8258V51.5078H88.0149V51.3187ZM88.7405 51.3187H88.9296V51.1297H88.7405V51.3187ZM88.7405 51.3187H88.5515V51.5078H88.7405V51.3187ZM92.6127 51.3187V51.5078H92.8017V51.3187H92.6127ZM92.6127 51.3187V51.1297H92.4236V51.3187H92.6127ZM96.9645 49.6363L97.1041 49.5089L96.9645 49.6363ZM93.1719 45.4778L93.0322 45.6052L93.0322 45.6052L93.1719 45.4778ZM92.6127 45.2311H92.4236V45.4203L92.6128 45.4202L92.6127 45.2311ZM88.7405 45.2155H92.6127V44.8374H88.7405V45.2155ZM88.9296 49.1114V45.0264H88.5515V49.1114H88.9296ZM88.4014 49.7637L88.8802 49.2388L88.6008 48.984L88.122 49.5089L88.4014 49.7637ZM88.204 50.2733C88.204 50.0848 88.2744 49.903 88.4014 49.7637L88.122 49.5089C87.9315 49.7179 87.8258 49.9905 87.8258 50.2733H88.204ZM88.204 51.3187V50.2733H87.8258V51.3187H88.204ZM88.7405 51.1297H88.0149V51.5078H88.7405V51.1297ZM88.9296 51.3187V51.3187H88.5515V51.3187H88.9296ZM92.6127 51.1297H88.7405V51.5078H92.6127V51.1297ZM92.4236 51.3187V51.3187H92.8017V51.3187H92.4236ZM96.4551 51.1297H92.6127V51.5078H96.4551V51.1297ZM97.0222 50.5625C97.0222 50.8757 96.7683 51.1297 96.4551 51.1297V51.5078C96.9771 51.5078 97.4004 51.0846 97.4004 50.5625H97.0222ZM97.0222 50.2733V50.5625H97.4004V50.2733H97.0222ZM96.8248 49.7637C96.9518 49.903 97.0222 50.0848 97.0222 50.2733H97.4004C97.4004 49.9905 97.2947 49.7179 97.1041 49.5089L96.8248 49.7637ZM93.0322 45.6052L96.8248 49.7637L97.1041 49.5089L93.3116 45.3504L93.0322 45.6052ZM92.6128 45.4202C92.7666 45.4201 92.9196 45.4817 93.0322 45.6052L93.3116 45.3504C93.124 45.1447 92.8679 45.0419 92.6126 45.0421L92.6128 45.4202ZM92.4236 45.0264V45.2311H92.8017V45.0264H92.4236Z",
    fill: "#161E1A",
    mask: "url(#path-177-inside-6_1133_595)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4322 54.2329C88.4322 53.0321 89.4056 52.0587 90.6064 52.0587H94.9426C96.1434 52.0587 97.1168 53.0321 97.1168 54.2329V63.1674C97.1168 64.3681 96.1434 65.3416 94.9426 65.3416H90.6064C89.4056 65.3416 88.4322 64.3681 88.4322 63.1674V54.2329Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3037 52.7204C84.3037 52.3027 84.6423 51.9641 85.06 51.9641H92.4212C92.8389 51.9641 93.1774 52.3027 93.1774 52.7204V64.8714H84.3037V52.7204Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2853 59.0933C85.2853 58.7279 85.5816 58.4316 85.947 58.4316H89.0328C89.3982 58.4316 89.6945 58.7279 89.6945 59.0933V61.1467H85.2853V59.0933Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2864 54.7371C85.2864 54.3716 85.5827 54.0753 85.9481 54.0753H89.0338C89.3993 54.0753 89.6956 54.3716 89.6956 54.7371V56.7904H85.2864V54.7371Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2879 54.7371C90.2879 54.3716 90.5842 54.0754 90.9496 54.0754H91.5345C91.9 54.0754 92.1963 54.3716 92.1963 54.7371V56.7904H90.2879V54.7371Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24 54.7371C94.24 54.3716 94.5363 54.0754 94.9018 54.0754H95.4867C95.8521 54.0754 96.1484 54.3716 96.1484 54.7371V56.7904H94.24V54.7371Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.24 59.0933C94.24 58.7278 94.5363 58.4316 94.9018 58.4316H95.4867C95.8521 58.4316 96.1484 58.7278 96.1484 59.0933V61.1466H94.24V59.0933Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.287 59.0933C90.287 58.7279 90.5833 58.4316 90.9488 58.4316H91.5337C91.8991 58.4316 92.1954 58.7279 92.1954 59.0933V61.1467H90.287V59.0933Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3814,
    y: 64.8046,
    width: 16.7517,
    height: 1.42435,
    rx: 0.712174,
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5305 45.4298C87.5305 45.2516 87.386 45.1071 87.2078 45.1071C87.0296 45.1071 86.8852 45.2516 86.8852 45.4298V48.1726C86.8852 48.3508 87.0296 48.4953 87.2078 48.4953C87.386 48.4953 87.5305 48.3508 87.5305 48.1726V45.4298Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2399 46.7205C86.2399 46.5423 86.0954 46.3979 85.9172 46.3979C85.739 46.3979 85.5945 46.5423 85.5945 46.7205V48.9793C85.5945 49.1575 85.739 49.302 85.9172 49.302C86.0954 49.302 86.2399 49.1575 86.2399 48.9793V46.7205Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5394 49.6392L88.1728 45.5102C88.474 45.168 89.0072 45.168 89.3083 45.5102L92.9418 49.6392C93.0937 49.8118 93.1774 50.0338 93.1774 50.2637V50.5625C93.1774 50.9802 92.8389 51.3187 92.4212 51.3187H85.06C84.6423 51.3187 84.3037 50.9801 84.3037 50.5625V50.2637C84.3037 50.0338 84.3875 49.8118 84.5394 49.6392Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 120.249,
    y: 46.4115,
    width: 8.68466,
    height: 19.3332,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M116.12 48.5858C116.12 47.3328 117.136 46.317 118.389 46.317H122.725C123.978 46.317 124.994 47.3328 124.994 48.5858V64.8712H116.12V48.5858Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M117.102 60.6057C117.102 59.405 118.076 58.4315 119.276 58.4315H120.85C121.215 58.4315 121.511 58.7278 121.511 59.0932V61.1466H117.102V60.6057Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M119.602 51.8933C119.602 50.6925 120.576 49.7191 121.777 49.7191H123.35C123.715 49.7191 124.012 50.0153 124.012 50.3808V52.4342H119.602V51.8933Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M117.101 56.2494C117.101 55.0486 118.075 54.0752 119.275 54.0752H120.849C121.214 54.0752 121.51 54.3715 121.51 54.7369V56.7903H117.101V56.2494Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M122.103 54.7369C122.103 54.3714 122.399 54.0752 122.765 54.0752H123.35C123.715 54.0752 124.012 54.3714 124.012 54.7369V56.7903H122.103V54.7369Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M126.057 50.3807C126.057 50.0153 126.353 49.719 126.718 49.719H127.303C127.669 49.719 127.965 50.0153 127.965 50.3807V52.4341H126.057V50.3807Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M126.057 54.7369C126.057 54.3714 126.353 54.0752 126.718 54.0752H127.303C127.669 54.0752 127.965 54.3714 127.965 54.7369V56.7903H126.057V54.7369Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M126.057 59.0931C126.057 58.7277 126.353 58.4314 126.718 58.4314H127.303C127.669 58.4314 127.965 58.7277 127.965 59.0931V61.1465H126.057V59.0931Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M122.102 59.0931C122.102 58.7277 122.398 58.4314 122.764 58.4314H123.349C123.714 58.4314 124.01 58.7277 124.01 59.0931V61.1465H122.102V59.0931Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M117.102 50.3808C117.102 50.0153 117.398 49.719 117.764 49.719H118.349C118.714 49.719 119.01 50.0153 119.01 50.3808V52.4341H117.102V50.3808Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 114.198,
    y: 64.8044,
    width: 16.7517,
    height: 1.42435,
    rx: 0.712174,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.39,
    y: 46.4115,
    width: 8.68466,
    height: 19.3332,
    rx: 2.17422,
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.261 48.5857C116.261 47.3327 117.277 46.317 118.53 46.317H122.866C124.119 46.317 125.135 47.3327 125.135 48.5857V64.8712H116.261V48.5857Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.245 60.6057C117.245 59.4049 118.218 58.4315 119.419 58.4315H120.992C121.358 58.4315 121.654 58.7278 121.654 59.0932V61.1466H117.245V60.6057Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.745 51.8933C119.745 50.6925 120.718 49.7191 121.919 49.7191H123.492C123.858 49.7191 124.154 50.0153 124.154 50.3808V52.4341H119.745V51.8933Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.245 56.2494C117.245 55.0487 118.218 54.0752 119.419 54.0752H120.992C121.358 54.0752 121.654 54.3715 121.654 54.7369V56.7903H117.245V56.2494Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.246 54.7369C122.246 54.3715 122.543 54.0752 122.908 54.0752H123.493C123.858 54.0752 124.155 54.3715 124.155 54.7369V56.7903H122.246V54.7369Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2 50.3807C126.2 50.0153 126.496 49.719 126.861 49.719H127.446C127.812 49.719 128.108 50.0153 128.108 50.3807V52.4341H126.2V50.3807Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2 54.7369C126.2 54.3715 126.496 54.0752 126.861 54.0752H127.446C127.812 54.0752 128.108 54.3715 128.108 54.7369V56.7903H126.2V54.7369Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.2 59.0931C126.2 58.7277 126.496 58.4314 126.861 58.4314H127.446C127.812 58.4314 128.108 58.7277 128.108 59.0931V61.1465H126.2V59.0931Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.245 59.0932C122.245 58.7277 122.542 58.4315 122.907 58.4315H123.492C123.858 58.4315 124.154 58.7277 124.154 59.0932V61.1465H122.245V59.0932Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.244 50.3808C117.244 50.0153 117.54 49.7191 117.906 49.7191H118.49C118.856 49.7191 119.152 50.0153 119.152 50.3808V52.4341H117.244V50.3808Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.339,
    y: 64.8044,
    width: 16.7517,
    height: 1.42435,
    rx: 0.712174,
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 153.355,
    y: 35.1177,
    width: 8.68466,
    height: 30.6271,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M149.227 37.2919C149.227 36.0389 150.243 35.0231 151.496 35.0231H155.832C157.085 35.0231 158.101 36.0389 158.101 37.2919V64.8712H149.227V37.2919Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 37.6046C150.209 37.0776 150.636 36.6504 151.163 36.6504C151.69 36.6504 152.117 37.0776 152.117 37.6046V39.3655H150.209V37.6046Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 41.9608C150.209 41.4338 150.636 41.0066 151.163 41.0066C151.69 41.0066 152.117 41.4338 152.117 41.9608V43.7217H150.209V41.9608Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 46.317C150.209 45.79 150.636 45.3628 151.163 45.3628C151.69 45.3628 152.117 45.79 152.117 46.317V48.0779H150.209V46.317Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 50.6732C150.209 50.1462 150.636 49.719 151.163 49.719C151.69 49.719 152.117 50.1462 152.117 50.6732V52.4341H150.209V50.6732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 55.0294C150.209 54.5024 150.636 54.0752 151.163 54.0752C151.69 54.0752 152.117 54.5024 152.117 55.0294V56.7903H150.209V55.0294Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M150.209 59.3857C150.209 58.8587 150.636 58.4315 151.163 58.4315C151.69 58.4315 152.117 58.8587 152.117 59.3857V61.1465H150.209V59.3857Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 37.6046C152.709 37.0777 153.136 36.6505 153.663 36.6505C154.19 36.6505 154.618 37.0777 154.618 37.6046V39.3655H152.709V37.6046Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 41.9608C152.709 41.4338 153.136 41.0066 153.663 41.0066C154.19 41.0066 154.618 41.4338 154.618 41.9608V43.7217H152.709V41.9608Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 46.317C152.709 45.79 153.136 45.3628 153.663 45.3628C154.19 45.3628 154.618 45.79 154.618 46.317V48.0779H152.709V46.317Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 50.6732C152.709 50.1462 153.136 49.719 153.663 49.719C154.19 49.719 154.618 50.1462 154.618 50.6732V52.4341H152.709V50.6732Z",
    fill: "#86D383",
    stroke: "#4F7C56",
    strokeWidth: 0.189062
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 55.0294C152.709 54.5024 153.136 54.0752 153.663 54.0752C154.19 54.0752 154.618 54.5024 154.618 55.0294V56.7903H152.709V55.0294Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 59.3857C152.709 58.8587 153.136 58.4315 153.663 58.4315C154.19 58.4315 154.618 58.8587 154.618 59.3857V61.1466H152.709V59.3857Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 37.6046C155.21 37.0776 155.637 36.6504 156.164 36.6504C156.691 36.6504 157.119 37.0776 157.119 37.6046V39.3655H155.21V37.6046Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M159.163 37.6046C159.163 37.0776 159.59 36.6504 160.117 36.6504C160.644 36.6504 161.072 37.0776 161.072 37.6046V39.3655H159.163V37.6046Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M159.163 41.9608C159.163 41.4338 159.59 41.0066 160.117 41.0066C160.644 41.0066 161.072 41.4338 161.072 41.9608V43.7217H159.163V41.9608Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M159.163 46.317C159.163 45.79 159.59 45.3628 160.117 45.3628C160.644 45.3628 161.072 45.79 161.072 46.317V48.0779H159.163V46.317Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M159.163 50.6732C159.163 50.1462 159.59 49.719 160.117 49.719C160.644 49.719 161.072 50.1462 161.072 50.6732V52.4341H159.163V50.6732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M159.163 55.0294C159.163 54.5024 159.59 54.0752 160.117 54.0752C160.644 54.0752 161.072 54.5024 161.072 55.0294V56.7903H159.163V55.0294Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M159.163 59.3857C159.163 58.8587 159.59 58.4315 160.117 58.4315C160.644 58.4315 161.072 58.8587 161.072 59.3857V61.1465H159.163V59.3857Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 41.9608C155.21 41.4338 155.637 41.0066 156.164 41.0066C156.691 41.0066 157.119 41.4338 157.119 41.9608V43.7217H155.21V41.9608Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 46.317C155.21 45.79 155.637 45.3628 156.164 45.3628C156.691 45.3628 157.119 45.79 157.119 46.317V48.0779H155.21V46.317Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 50.6732C155.21 50.1462 155.637 49.719 156.164 49.719C156.691 49.719 157.119 50.1462 157.119 50.6732V52.4341H155.21V50.6732Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 55.0294C155.21 54.5024 155.637 54.0752 156.164 54.0752C156.691 54.0752 157.119 54.5024 157.119 55.0294V56.7903H155.21V55.0294Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M155.21 59.3857C155.21 58.8587 155.637 58.4315 156.164 58.4315C156.691 58.4315 157.119 58.8587 157.119 59.3857V61.1465H155.21V59.3857Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-241-inside-7_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.615 50.6732C152.615 50.094 153.084 49.6245 153.663 49.6245C154.243 49.6245 154.712 50.094 154.712 50.6732V52.5286H152.615V50.6732Z"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M152.615 50.6732C152.615 50.094 153.084 49.6245 153.663 49.6245C154.243 49.6245 154.712 50.094 154.712 50.6732V52.5286H152.615V50.6732Z",
    fill: "#597364"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M154.712 52.5286V52.7177H154.901V52.5286H154.712ZM152.615 52.5286H152.426V52.7177H152.615V52.5286ZM154.523 50.6732V52.5286H154.901V50.6732H154.523ZM154.712 52.3396H152.615V52.7177H154.712V52.3396ZM152.804 52.5286V50.6732H152.426V52.5286H152.804ZM153.663 49.8136C154.138 49.8136 154.523 50.1985 154.523 50.6732H154.901C154.901 49.9896 154.347 49.4354 153.663 49.4354V49.8136ZM153.663 49.4354C152.98 49.4354 152.426 49.9896 152.426 50.6732H152.804C152.804 50.1985 153.189 49.8136 153.663 49.8136V49.4354Z",
    fill: "#161E1A",
    mask: "url(#path-241-inside-7_1133_595)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 147.305,
    y: 64.8044,
    width: 16.7517,
    height: 1.42435,
    rx: 0.712174,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.634,
    y: 35.1176,
    width: 8.68466,
    height: 30.6271,
    rx: 2.17422,
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.506 37.2918C149.506 36.0389 150.521 35.0231 151.774 35.0231H156.111C157.364 35.0231 158.379 36.0389 158.379 37.2918V64.8712H149.506V37.2918Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.488 37.6046C150.488 37.0776 150.916 36.6504 151.443 36.6504C151.969 36.6504 152.397 37.0776 152.397 37.6046V39.3655H150.488V37.6046Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.488 41.9608C150.488 41.4338 150.916 41.0066 151.443 41.0066C151.969 41.0066 152.397 41.4338 152.397 41.9608V43.7217H150.488V41.9608Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.488 46.317C150.488 45.79 150.916 45.3628 151.443 45.3628C151.969 45.3628 152.397 45.79 152.397 46.317V48.0779H150.488V46.317Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.488 50.6732C150.488 50.1462 150.916 49.719 151.443 49.719C151.969 49.719 152.397 50.1462 152.397 50.6732V52.4341H150.488V50.6732Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.488 55.0294C150.488 54.5024 150.916 54.0752 151.443 54.0752C151.969 54.0752 152.397 54.5024 152.397 55.0294V56.7903H150.488V55.0294Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.488 59.3856C150.488 58.8586 150.916 58.4314 151.443 58.4314C151.969 58.4314 152.397 58.8586 152.397 59.3856V61.1465H150.488V59.3856Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 37.6046C152.988 37.0776 153.416 36.6504 153.943 36.6504C154.469 36.6504 154.897 37.0776 154.897 37.6046V39.3655H152.988V37.6046Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 41.9608C152.988 41.4338 153.416 41.0066 153.943 41.0066C154.469 41.0066 154.897 41.4338 154.897 41.9608V43.7217H152.988V41.9608Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 46.317C152.988 45.79 153.416 45.3628 153.943 45.3628C154.469 45.3628 154.897 45.79 154.897 46.317V48.0779H152.988V46.317Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 50.6732C152.988 50.1462 153.416 49.719 153.943 49.719C154.469 49.719 154.897 50.1462 154.897 50.6732V52.4341H152.988V50.6732Z",
    fill: "#86D383",
    stroke: "#4F7C56",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 55.0294C152.988 54.5024 153.416 54.0752 153.943 54.0752C154.469 54.0752 154.897 54.5024 154.897 55.0294V56.7903H152.988V55.0294Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.988 59.3856C152.988 58.8586 153.416 58.4314 153.943 58.4314C154.469 58.4314 154.897 58.8586 154.897 59.3856V61.1465H152.988V59.3856Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.489 37.6046C155.489 37.0776 155.917 36.6504 156.444 36.6504C156.971 36.6504 157.398 37.0776 157.398 37.6046V39.3655H155.489V37.6046Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 37.6046C159.442 37.0776 159.87 36.6504 160.397 36.6504C160.924 36.6504 161.351 37.0776 161.351 37.6046V39.3655H159.442V37.6046Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 41.9608C159.442 41.4338 159.87 41.0066 160.397 41.0066C160.924 41.0066 161.351 41.4338 161.351 41.9608V43.7217H159.442V41.9608Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 46.317C159.442 45.79 159.87 45.3628 160.397 45.3628C160.924 45.3628 161.351 45.79 161.351 46.317V48.0779H159.442V46.317Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 50.6732C159.442 50.1462 159.87 49.719 160.397 49.719C160.924 49.719 161.351 50.1462 161.351 50.6732V52.4341H159.442V50.6732Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 55.0294C159.442 54.5024 159.87 54.0752 160.397 54.0752C160.924 54.0752 161.351 54.5024 161.351 55.0294V56.7903H159.442V55.0294Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.442 59.3856C159.442 58.8586 159.87 58.4314 160.397 58.4314C160.924 58.4314 161.351 58.8586 161.351 59.3856V61.1465H159.442V59.3856Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.489 41.9608C155.489 41.4338 155.917 41.0066 156.444 41.0066C156.971 41.0066 157.398 41.4338 157.398 41.9608V43.7217H155.489V41.9608Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.489 46.317C155.489 45.79 155.917 45.3628 156.444 45.3628C156.971 45.3628 157.398 45.79 157.398 46.317V48.0779H155.489V46.317Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.489 50.6732C155.489 50.1462 155.917 49.719 156.444 49.719C156.971 49.719 157.398 50.1462 157.398 50.6732V52.4341H155.489V50.6732Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.489 55.0294C155.489 54.5024 155.917 54.0752 156.444 54.0752C156.971 54.0752 157.398 54.5024 157.398 55.0294V56.7903H155.489V55.0294Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.489 59.3856C155.489 58.8586 155.917 58.4314 156.444 58.4314C156.971 58.4314 157.398 58.8586 157.398 59.3856V61.1465H155.489V59.3856Z",
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-270-inside-8_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.894 50.6732C152.894 50.094 153.364 49.6245 153.943 49.6245C154.522 49.6245 154.992 50.094 154.992 50.6732V52.5286H152.894V50.6732Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.894 50.6732C152.894 50.094 153.364 49.6245 153.943 49.6245C154.522 49.6245 154.992 50.094 154.992 50.6732V52.5286H152.894V50.6732Z",
    fill: "#161E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.992 52.5286V52.7177H155.181V52.5286H154.992ZM152.894 52.5286H152.705V52.7177H152.894V52.5286ZM154.803 50.6732V52.5286H155.181V50.6732H154.803ZM154.992 52.3395H152.894V52.7177H154.992V52.3395ZM153.083 52.5286V50.6732H152.705V52.5286H153.083ZM153.943 49.8135C154.418 49.8135 154.803 50.1984 154.803 50.6732H155.181C155.181 49.9896 154.627 49.4354 153.943 49.4354V49.8135ZM153.943 49.4354C153.259 49.4354 152.705 49.9896 152.705 50.6732H153.083C153.083 50.1984 153.468 49.8135 153.943 49.8135V49.4354Z",
    fill: "#161E1A",
    mask: "url(#path-270-inside-8_1133_595)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.584,
    y: 64.8044,
    width: 16.7517,
    height: 1.42435,
    rx: 0.712174,
    fill: "#161E1A",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 139.105,
    y: 47.1663,
    width: 7.59791,
    height: 33.4897,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M131.223 48.351C131.223 47.5871 131.608 46.8745 132.246 46.455L139.01 42.0103V79.5825H131.223V48.351Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M132.291 51.4295C132.291 51.0641 132.587 50.7678 132.953 50.7678H133.971C134.337 50.7678 134.633 51.0641 134.633 51.4295V54.0829H132.291V51.4295Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M132.291 56.6857C132.291 56.3203 132.587 56.024 132.953 56.024H133.971C134.337 56.024 134.633 56.3203 134.633 56.6857V59.3391H132.291V56.6857Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M132.291 61.942C132.291 61.5765 132.587 61.2803 132.953 61.2803H133.971C134.337 61.2803 134.633 61.5765 134.633 61.942V64.5953H132.291V61.942Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M132.291 67.1982C132.291 66.8327 132.587 66.5365 132.953 66.5365H133.971C134.337 66.5365 134.633 66.8327 134.633 67.1982V69.8516H132.291V67.1982Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M132.291 72.4544C132.291 72.089 132.587 71.7927 132.953 71.7927H133.971C134.337 71.7927 134.633 72.089 134.633 72.4544V75.1078H132.291V72.4544Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M140.077 51.4296C140.077 51.0641 140.373 50.7678 140.739 50.7678H141.757C142.123 50.7678 142.419 51.0641 142.419 51.4296V54.0829H140.077V51.4296Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M140.077 56.6858C140.077 56.3203 140.373 56.024 140.739 56.024H141.757C142.123 56.024 142.419 56.3203 142.419 56.6858V59.3391H140.077V56.6858Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M140.077 61.942C140.077 61.5765 140.373 61.2803 140.739 61.2803H141.757C142.123 61.2803 142.419 61.5765 142.419 61.942V64.5953H140.077V61.942Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M140.077 67.1982C140.077 66.8327 140.373 66.5365 140.739 66.5365H141.757C142.123 66.5365 142.419 66.8327 142.419 67.1982V69.8516H140.077V67.1982Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M140.077 72.4545C140.077 72.089 140.373 71.7927 140.739 71.7927H141.757C142.123 71.7927 142.419 72.089 142.419 72.4545V75.1078H140.077V72.4545Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 51.4296C135.6 51.0641 135.896 50.7678 136.261 50.7678H137.28C137.645 50.7678 137.941 51.0641 137.941 51.4296V54.0829H135.6V51.4296Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 56.6858C135.6 56.3203 135.896 56.024 136.261 56.024H137.28C137.645 56.024 137.941 56.3203 137.941 56.6858V59.3391H135.6V56.6858Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 61.942C135.6 61.5765 135.896 61.2803 136.261 61.2803H137.28C137.645 61.2803 137.941 61.5765 137.941 61.942V64.5953H135.6V61.942Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 67.1982C135.6 66.8327 135.896 66.5365 136.261 66.5365H137.28C137.645 66.5365 137.941 66.8327 137.941 67.1982V69.8516H135.6V67.1982Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M135.6 72.4545C135.6 72.089 135.896 71.7927 136.261 71.7927H137.28C137.645 71.7927 137.941 72.089 137.941 72.4545V75.1078H135.6V72.4545Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M143.387 51.4295C143.387 51.0641 143.683 50.7678 144.049 50.7678H145.067C145.433 50.7678 145.729 51.0641 145.729 51.4295V54.0829H143.387V51.4295Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M143.387 56.6858C143.387 56.3203 143.683 56.024 144.049 56.024H145.067C145.433 56.024 145.729 56.3203 145.729 56.6858V59.3391H143.387V56.6858Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M143.387 61.942C143.387 61.5766 143.683 61.2803 144.049 61.2803H145.067C145.433 61.2803 145.729 61.5766 145.729 61.942V64.5954H143.387V61.942Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M143.387 67.1982C143.387 66.8328 143.683 66.5365 144.049 66.5365H145.067C145.433 66.5365 145.729 66.8328 145.729 67.1982V69.8516H143.387V67.1982Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M143.387 72.4545C143.387 72.089 143.683 71.7927 144.049 71.7927H145.067C145.433 71.7927 145.729 72.089 145.729 72.4545V75.1078H143.387V72.4545Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 128.885,
    y: 79.4824,
    width: 20.2517,
    height: 1.75769,
    rx: 0.878843,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 72.3869,
    y: 57.2894,
    width: 10.518,
    height: 23.3666,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4255 59.4636C67.4255 58.2106 68.4413 57.1949 69.6943 57.1949H75.8639C77.1169 57.1949 78.1326 58.2106 78.1326 59.4636V79.5825H67.4255V59.4636Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5915 73.9669C68.5915 72.7661 69.5649 71.7927 70.7657 71.7927H73.2889C73.6544 71.7927 73.9506 72.0889 73.9506 72.4544V75.1078H68.5915V73.9669Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6089 63.4545C71.6089 62.2537 72.5824 61.2803 73.7832 61.2803H76.3064C76.6718 61.2803 76.9681 61.5765 76.9681 61.942V64.5953H71.6089V63.4545Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5916 68.7106C68.5916 67.5099 69.565 66.5364 70.7658 66.5364H73.289C73.6545 66.5364 73.9508 66.8327 73.9508 67.1981V69.8515H68.5916V68.7106Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M74.626 67.1981C74.626 66.8327 74.9223 66.5364 75.2877 66.5364H76.306C76.6715 66.5364 76.9677 66.8327 76.9677 67.1981V69.8515H74.626V67.1981Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3959 61.942C79.3959 61.5765 79.6922 61.2802 80.0576 61.2802H81.0759C81.4414 61.2802 81.7376 61.5765 81.7376 61.942V64.5953H79.3959V61.942Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3959 67.1982C79.3959 66.8327 79.6922 66.5364 80.0576 66.5364H81.0759C81.4414 66.5364 81.7376 66.8327 81.7376 67.1982V69.8515H79.3959V67.1982Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3959 72.4545C79.3959 72.089 79.6922 71.7928 80.0576 71.7928H81.0759C81.4414 71.7928 81.7376 72.089 81.7376 72.4545V75.1078H79.3959V72.4545Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6261 72.4544C74.6261 72.0889 74.9224 71.7927 75.2879 71.7927H76.3061C76.6716 71.7927 76.9679 72.0889 76.9679 72.4544V75.1078H74.6261V72.4544Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5915 61.9419C68.5915 61.5765 68.8877 61.2802 69.2532 61.2802H70.2715C70.6369 61.2802 70.9332 61.5765 70.9332 61.9419V64.5953H68.5915V61.9419Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0867,
    y: 79.4824,
    width: 20.2517,
    height: 1.75769,
    rx: 0.878843,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 104.188,
    y: 43.6621,
    width: 10.518,
    height: 36.9938,
    rx: 2.17422,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2263 45.8363C99.2263 44.5833 100.242 43.5676 101.495 43.5676H107.665C108.918 43.5676 109.933 44.5833 109.933 45.8363V79.5824H99.2263V45.8363Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 104.188,
    y: 39.9633,
    width: 10.518,
    height: 2.73106,
    rx: 1.36553,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 99.2263,
    y: 39.8688,
    width: 10.7071,
    height: 2.92012,
    rx: 1.46006,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 46.6824C100.392 46.0358 100.916 45.5116 101.563 45.5116C102.209 45.5116 102.733 46.0358 102.733 46.6824V48.8266H100.392V46.6824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 51.9386C100.392 51.292 100.916 50.7678 101.563 50.7678C102.209 50.7678 102.733 51.292 102.733 51.9386V54.0828H100.392V51.9386Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 57.1948C100.392 56.5482 100.916 56.024 101.563 56.024C102.209 56.024 102.733 56.5482 102.733 57.1948V59.339H100.392V57.1948Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 62.451C100.392 61.8044 100.916 61.2802 101.563 61.2802C102.209 61.2802 102.733 61.8044 102.733 62.451V64.5953H100.392V62.451Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 67.7073C100.392 67.0606 100.916 66.5364 101.563 66.5364C102.209 66.5364 102.733 67.0606 102.733 67.7073V69.8515H100.392V67.7073Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M100.392 72.9635C100.392 72.3169 100.916 71.7927 101.563 71.7927C102.209 71.7927 102.733 72.3169 102.733 72.9635V75.1077H100.392V72.9635Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 46.6824C103.41 46.0358 103.934 45.5116 104.58 45.5116C105.227 45.5116 105.751 46.0358 105.751 46.6824V48.8267H103.41V46.6824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 51.9386C103.41 51.292 103.934 50.7678 104.58 50.7678C105.227 50.7678 105.751 51.292 105.751 51.9386V54.0829H103.41V51.9386Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 57.1949C103.41 56.5482 103.934 56.024 104.58 56.024C105.227 56.024 105.751 56.5482 105.751 57.1949V59.3391H103.41V57.1949Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 62.4511C103.41 61.8044 103.934 61.2802 104.58 61.2802C105.227 61.2802 105.751 61.8044 105.751 62.4511V64.5953H103.41V62.4511Z",
    fill: "#86D383",
    stroke: "#4F7C56",
    strokeWidth: 0.189062
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 67.7073C103.41 67.0606 103.934 66.5364 104.58 66.5364C105.227 66.5364 105.751 67.0606 105.751 67.7073V69.8515H103.41V67.7073Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M103.41 72.9635C103.41 72.3169 103.934 71.7927 104.58 71.7927C105.227 71.7927 105.751 72.3169 105.751 72.9635V75.1078H103.41V72.9635Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M106.427 46.6824C106.427 46.0358 106.951 45.5116 107.598 45.5116C108.244 45.5116 108.769 46.0358 108.769 46.6824V48.8267H106.427V46.6824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M111.197 46.6824C111.197 46.0358 111.721 45.5116 112.367 45.5116C113.014 45.5116 113.538 46.0358 113.538 46.6824V48.8267H111.197V46.6824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M111.197 51.9386C111.197 51.292 111.721 50.7678 112.367 50.7678C113.014 50.7678 113.538 51.292 113.538 51.9386V54.0829H111.197V51.9386Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M111.197 57.1949C111.197 56.5482 111.721 56.024 112.367 56.024C113.014 56.024 113.538 56.5482 113.538 57.1949V59.3391H111.197V57.1949Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M111.197 62.4511C111.197 61.8044 111.721 61.2802 112.367 61.2802C113.014 61.2802 113.538 61.8044 113.538 62.4511V64.5953H111.197V62.4511Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M111.197 67.7073C111.197 67.0606 111.721 66.5364 112.367 66.5364C113.014 66.5364 113.538 67.0606 113.538 67.7073V69.8515H111.197V67.7073Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M111.197 72.9635C111.197 72.3169 111.721 71.7927 112.367 71.7927C113.014 71.7927 113.538 72.3169 113.538 72.9635V75.1078H111.197V72.9635Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M106.427 51.9386C106.427 51.292 106.951 50.7678 107.598 50.7678C108.244 50.7678 108.769 51.292 108.769 51.9386V54.0829H106.427V51.9386Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M106.427 57.1949C106.427 56.5482 106.951 56.024 107.598 56.024C108.244 56.024 108.769 56.5482 108.769 57.1949V59.3391H106.427V57.1949Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M106.427 62.4511C106.427 61.8044 106.951 61.2802 107.598 61.2802C108.244 61.2802 108.769 61.8044 108.769 62.4511V64.5953H106.427V62.4511Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M106.427 67.7073C106.427 67.0606 106.951 66.5364 107.598 66.5364C108.244 66.5364 108.769 67.0606 108.769 67.7073V69.8515H106.427V67.7073Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M106.427 72.9635C106.427 72.3169 106.951 71.7927 107.598 71.7927C108.244 71.7927 108.769 72.3169 108.769 72.9635V75.1078H106.427V72.9635Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-336-inside-9_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.314 62.4511C103.314 61.7523 103.881 61.1858 104.58 61.1858C105.278 61.1858 105.845 61.7523 105.845 62.4511V64.6899H103.314V62.4511Z"
  }))), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M103.314 62.4511C103.314 61.7523 103.881 61.1858 104.58 61.1858C105.278 61.1858 105.845 61.7523 105.845 62.4511V64.6899H103.314V62.4511Z",
    fill: "#597364"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M105.845 64.6899V64.879H106.034V64.6899H105.845ZM103.314 64.6899H103.125V64.879H103.314V64.6899ZM105.656 62.4511V64.6899H106.034V62.4511H105.656ZM105.845 64.5008H103.314V64.879H105.845V64.5008ZM103.503 64.6899V62.4511H103.125V64.6899H103.503ZM104.58 61.3748C105.174 61.3748 105.656 61.8567 105.656 62.4511H106.034C106.034 61.6479 105.383 60.9967 104.58 60.9967V61.3748ZM104.58 60.9967C103.776 60.9967 103.125 61.6479 103.125 62.4511H103.503C103.503 61.8567 103.985 61.3748 104.58 61.3748V60.9967Z",
    fill: "#161E1A",
    mask: "url(#path-336-inside-9_1133_595)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 96.888,
    y: 79.4823,
    width: 20.2517,
    height: 1.75769,
    rx: 0.878843,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 96.5538,
    y: 37.6216,
    width: 21.1146,
    height: 46.3495,
    rx: 1.13437,
    stroke: "url(#paint2_linear_1133_595)",
    strokeWidth: 0.756249,
    strokeDasharray: "1.51 1.51"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-340-inside-10_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.357 55.6374H169.684V60.5654L169.055 61.2557C168.896 61.4298 168.808 61.657 168.808 61.8927V63.2297H179.148C179.566 63.2297 179.904 62.8912 179.904 62.4735V61.8927C179.904 61.657 179.816 61.4298 179.658 61.2557L174.915 56.0554C174.765 55.8911 174.561 55.8089 174.357 55.8088V55.6374Z"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.357 55.6374H169.684V60.5654L169.055 61.2557C168.896 61.4298 168.808 61.657 168.808 61.8927V63.2297H179.148C179.566 63.2297 179.904 62.8912 179.904 62.4735V61.8927C179.904 61.657 179.816 61.4298 179.658 61.2557L174.915 56.0554C174.765 55.8911 174.561 55.8089 174.357 55.8088V55.6374Z",
    fill: "#678D7C"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M169.684 55.6374V55.4483H169.495V55.6374H169.684ZM174.357 55.6374H174.546V55.4483H174.357V55.6374ZM169.684 60.5654L169.824 60.6928L169.873 60.6387V60.5654H169.684ZM169.055 61.2557L169.195 61.3831L169.195 61.3831L169.055 61.2557ZM168.808 63.2297H168.619V63.4188H168.808V63.2297ZM179.658 61.2557L179.518 61.3831V61.3831L179.658 61.2557ZM174.915 56.0554L174.775 56.1828V56.1828L174.915 56.0554ZM174.357 55.8088H174.168V55.9978L174.357 55.9978L174.357 55.8088ZM169.684 55.8265H174.357V55.4483H169.684V55.8265ZM169.873 60.5654V55.6374H169.495V60.5654H169.873ZM169.195 61.3831L169.824 60.6928L169.545 60.438L168.915 61.1283L169.195 61.3831ZM168.997 61.8927C168.997 61.7041 169.068 61.5224 169.195 61.3831L168.915 61.1283C168.725 61.3372 168.619 61.6098 168.619 61.8927H168.997ZM168.997 63.2297V61.8927H168.619V63.2297H168.997ZM179.148 63.0407H168.808V63.4188H179.148V63.0407ZM179.715 62.4735C179.715 62.7867 179.461 63.0407 179.148 63.0407V63.4188C179.67 63.4188 180.094 62.9956 180.094 62.4735H179.715ZM179.715 61.8927V62.4735H180.094V61.8927H179.715ZM179.518 61.3831C179.645 61.5224 179.715 61.7041 179.715 61.8927H180.094C180.094 61.6098 179.988 61.3372 179.797 61.1283L179.518 61.3831ZM174.775 56.1828L179.518 61.3831L179.797 61.1283L175.055 55.928L174.775 56.1828ZM174.357 55.9978C174.51 55.9979 174.663 56.0595 174.775 56.1828L175.055 55.928C174.867 55.7227 174.612 55.6198 174.357 55.6197L174.357 55.9978ZM174.168 55.6374V55.8088H174.546V55.6374H174.168Z",
    fill: "#161E1A",
    mask: "url(#path-340-inside-10_1133_595)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M169.292 66.2772C169.292 65.0764 170.265 64.103 171.466 64.103H177.636C178.837 64.103 179.81 65.0764 179.81 66.2772V77.9951C179.81 79.1958 178.837 80.1693 177.636 80.1693H171.466C170.265 80.1693 169.292 79.1958 169.292 77.9951V66.2772Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M164.331 64.7647C164.331 64.347 164.67 64.0084 165.087 64.0084H174.282C174.7 64.0084 175.038 64.347 175.038 64.7647V79.5824H164.331V64.7647Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M165.496 72.4544C165.496 72.0889 165.792 71.7926 166.158 71.7926H170.193C170.559 71.7926 170.855 72.0889 170.855 72.4544V75.1077H165.496V72.4544Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M165.496 67.1981C165.496 66.8326 165.792 66.5364 166.158 66.5364H170.193C170.559 66.5364 170.855 66.8326 170.855 67.1981V69.8515H165.496V67.1981Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M171.531 67.1981C171.531 66.8326 171.828 66.5364 172.193 66.5364H173.211C173.577 66.5364 173.873 66.8326 173.873 67.1981V69.8514H171.531V67.1981Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M176.3 67.1981C176.3 66.8326 176.596 66.5364 176.962 66.5364H177.98C178.346 66.5364 178.642 66.8326 178.642 67.1981V69.8514H176.3V67.1981Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M176.3 72.4542C176.3 72.0888 176.596 71.7925 176.962 71.7925H177.98C178.346 71.7925 178.642 72.0888 178.642 72.4542V75.1076H176.3V72.4542Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M171.531 72.4543C171.531 72.0889 171.827 71.7926 172.193 71.7926H173.211C173.576 71.7926 173.873 72.0889 173.873 72.4543V75.1077H171.531V72.4543Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 161.992,
    y: 79.4823,
    width: 20.2517,
    height: 1.75769,
    rx: 0.878843,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.189062
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M168.224 56.1241C168.224 55.9091 168.05 55.7348 167.835 55.7348C167.62 55.7348 167.445 55.9091 167.445 56.1241V59.4336C167.445 59.6486 167.62 59.8229 167.835 59.8229C168.05 59.8229 168.224 59.6486 168.224 59.4336V56.1241Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M166.667 57.6815C166.667 57.4665 166.492 57.2922 166.277 57.2922C166.062 57.2922 165.888 57.4665 165.888 57.6815V60.407C165.888 60.622 166.062 60.7963 166.277 60.7963C166.492 60.7963 166.667 60.622 166.667 60.407V57.6815Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M164.567 61.2585L169.117 56.0879C169.418 55.7457 169.951 55.7457 170.252 56.0879L174.803 61.2585C174.954 61.4311 175.038 61.6531 175.038 61.883V62.4735C175.038 62.8911 174.7 63.2297 174.282 63.2297H165.087C164.67 63.2297 164.331 62.8911 164.331 62.4735V61.883C164.331 61.6531 164.415 61.4311 164.567 61.2585Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.189062,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 160.352,
    y: 52.8034,
    width: 22.6606,
    height: 31.0182,
    rx: 1.13437,
    stroke: "url(#paint3_linear_1133_595)",
    strokeWidth: 0.756249,
    strokeDasharray: "1.51 1.51"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1133_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3882 2.00003C44.3882 0.895461 45.2836 3.05176e-05 46.3882 3.05176e-05H202.109C203.213 3.05176e-05 204.109 0.895461 204.109 2.00003V9.52438H44.3882V2.00003Z",
    fill: "url(#paint4_radial_1133_595)",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6479 5.91007H49.6188C49.597 5.96089 49.5704 6.0105 49.539 6.0589C49.5075 6.1073 49.4688 6.14965 49.4228 6.18595C49.3768 6.22225 49.3224 6.25129 49.2594 6.27307C49.1989 6.29485 49.1288 6.30574 49.0489 6.30574C48.7924 6.30574 48.5976 6.19321 48.4645 5.96815C48.3338 5.74067 48.2685 5.42244 48.2685 5.01346C48.2685 4.5827 48.3459 4.25358 48.5008 4.0261C48.6557 3.79862 48.894 3.68488 49.2159 3.68488C49.3417 3.68488 49.4518 3.70182 49.5462 3.7357C49.643 3.76958 49.7253 3.81677 49.7931 3.87727C49.8632 3.93777 49.9201 4.01037 49.9637 4.09507C50.0096 4.17735 50.0459 4.26689 50.0726 4.36369L49.637 4.48711C49.62 4.43387 49.6007 4.38184 49.5789 4.33102C49.5595 4.2802 49.5329 4.23664 49.499 4.20034C49.4676 4.16162 49.4288 4.13137 49.3829 4.10959C49.3369 4.08539 49.28 4.07329 49.2123 4.07329C49.055 4.07329 48.9424 4.13621 48.8747 4.26205C48.8069 4.38789 48.773 4.55971 48.773 4.77751V5.18407C48.773 5.29297 48.7803 5.3934 48.7948 5.48536C48.8117 5.5749 48.8384 5.65234 48.8747 5.71768C48.911 5.78302 48.9582 5.83384 49.0162 5.87014C49.0743 5.90402 49.1469 5.92096 49.234 5.92096C49.3696 5.92096 49.4724 5.88103 49.5426 5.80117C49.6128 5.71889 49.6479 5.61483 49.6479 5.48899V5.28208H49.1868V4.93723H50.0726V6.26218H49.6479V5.91007ZM51.0621 6.26218H50.5866V3.72844H51.5486C51.7954 3.72844 51.9842 3.79862 52.1148 3.93898C52.2455 4.07934 52.3109 4.27052 52.3109 4.51252C52.3109 4.69886 52.2673 4.85616 52.1802 4.98442C52.0955 5.11026 51.9733 5.19012 51.8135 5.224L52.3544 6.26218H51.8317L51.3489 5.27845H51.0621V6.26218ZM51.4505 4.90819C51.5788 4.90819 51.6708 4.88278 51.7264 4.83196C51.7821 4.77872 51.8099 4.69523 51.8099 4.58149V4.44355C51.8099 4.32981 51.7821 4.24753 51.7264 4.19671C51.6708 4.14347 51.5788 4.11685 51.4505 4.11685H51.0621V4.90819H51.4505ZM53.5618 6.30574C53.3972 6.30574 53.2545 6.2767 53.1335 6.21862C53.0125 6.15812 52.912 6.07221 52.8322 5.96089C52.7547 5.84957 52.6966 5.71284 52.6579 5.5507C52.6216 5.38856 52.6035 5.20343 52.6035 4.99531C52.6035 4.78961 52.6216 4.60569 52.6579 4.44355C52.6966 4.27899 52.7547 4.14105 52.8322 4.02973C52.912 3.91841 53.0125 3.83371 53.1335 3.77563C53.2545 3.71513 53.3972 3.68488 53.5618 3.68488C53.8909 3.68488 54.1329 3.79983 54.2878 4.02973C54.4427 4.25963 54.5201 4.58149 54.5201 4.99531C54.5201 5.40913 54.4427 5.73099 54.2878 5.96089C54.1329 6.19079 53.8909 6.30574 53.5618 6.30574ZM53.5618 5.91733C53.6465 5.91733 53.7179 5.9016 53.776 5.87014C53.834 5.83626 53.88 5.78907 53.9139 5.72857C53.9502 5.66807 53.9756 5.59426 53.9901 5.50714C54.0071 5.4176 54.0155 5.31838 54.0155 5.20948V4.77751C54.0155 4.55971 53.9817 4.38789 53.9139 4.26205C53.8486 4.13621 53.7312 4.07329 53.5618 4.07329C53.3924 4.07329 53.2738 4.13621 53.2061 4.26205C53.1407 4.38789 53.108 4.55971 53.108 4.77751V5.21311C53.108 5.43091 53.1407 5.60273 53.2061 5.72857C53.2738 5.85441 53.3924 5.91733 53.5618 5.91733ZM56.2393 5.08969L56.2611 4.35643H56.2284L55.7384 5.6596L55.2483 4.35643H55.2157L55.2374 5.08969V6.26218H54.8236V3.72844H55.3899L55.742 4.66135H55.7674L56.1232 3.72844H56.6531V6.26218H56.2393V5.08969ZM58.4558 6.26218L58.278 5.61967H57.5265L57.3523 6.26218H56.8731L57.5846 3.72844H58.2453L58.9604 6.26218H58.4558ZM57.9186 4.19671H57.8895L57.61 5.23126H58.1981L57.9186 4.19671ZM61.4804 6.26218V3.72844H63.1357V4.12048H61.9559V4.78114H63.0195V5.17318H61.9559V6.26218H61.4804ZM64.0563 3.72844V5.30749C64.0563 5.40187 64.0587 5.48657 64.0635 5.56159C64.0708 5.63661 64.0865 5.70074 64.1107 5.75398C64.1374 5.8048 64.1761 5.84473 64.2269 5.87377C64.2801 5.90281 64.3527 5.91733 64.4447 5.91733C64.5367 5.91733 64.608 5.90281 64.6589 5.87377C64.7121 5.84473 64.7508 5.8048 64.775 5.75398C64.8016 5.70074 64.8174 5.63661 64.8222 5.56159C64.8295 5.48657 64.8331 5.40187 64.8331 5.30749V3.72844H65.3086V5.23489C65.3086 5.41397 65.2977 5.57006 65.276 5.70316C65.2542 5.83626 65.2118 5.94758 65.1489 6.03712C65.086 6.12666 64.9977 6.19442 64.8839 6.2404C64.7726 6.28396 64.6262 6.30574 64.4447 6.30574C64.2632 6.30574 64.1156 6.28396 64.0018 6.2404C63.8905 6.19442 63.8034 6.12666 63.7405 6.03712C63.6776 5.94758 63.6352 5.83626 63.6134 5.70316C63.5916 5.57006 63.5808 5.41397 63.5808 5.23489V3.72844H64.0563ZM66.2183 4.44355H66.182V6.26218H65.7755V3.72844H66.3599L67.0242 5.54707H67.0605V3.72844H67.4671V6.26218H66.8826L66.2183 4.44355ZM67.9738 3.72844H68.7616C69.0907 3.72844 69.3351 3.83734 69.4948 4.05514C69.657 4.27294 69.738 4.58633 69.738 4.99531C69.738 5.40671 69.657 5.72131 69.4948 5.93911C69.3351 6.15449 69.0907 6.26218 68.7616 6.26218H67.9738V3.72844ZM68.7289 5.88103C68.9031 5.88103 69.0314 5.82416 69.1137 5.71042C69.1984 5.59668 69.2407 5.43091 69.2407 5.21311V4.77388C69.2407 4.5585 69.1984 4.39394 69.1137 4.2802C69.0314 4.16646 68.9031 4.10959 68.7289 4.10959H68.4421V5.88103H68.7289ZM72.3452 6.26218V5.90644H72.9151V4.08418H72.3452V3.72844H73.9569V4.08418H73.387V5.90644H73.9569V6.26218H72.3452Z",
    fill: "#FAF7F3"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M172.92 4.7521C173.072 4.7521 173.184 4.72185 173.254 4.66135C173.327 4.60085 173.363 4.52462 173.363 4.43266V4.40725C173.363 4.30319 173.328 4.22212 173.258 4.16404C173.19 4.10596 173.095 4.07692 172.974 4.07692C172.858 4.07692 172.757 4.10354 172.67 4.15678C172.582 4.21002 172.507 4.28504 172.444 4.38184L172.136 4.10596C172.179 4.04788 172.228 3.99343 172.281 3.94261C172.337 3.88937 172.398 3.8446 172.466 3.8083C172.536 3.76958 172.614 3.73933 172.699 3.71755C172.783 3.69577 172.88 3.68488 172.989 3.68488C173.117 3.68488 173.235 3.70061 173.341 3.73207C173.45 3.76111 173.542 3.80467 173.617 3.86275C173.694 3.92083 173.754 3.99101 173.795 4.07329C173.838 4.15315 173.86 4.2439 173.86 4.34554C173.86 4.4254 173.847 4.498 173.82 4.56334C173.794 4.62868 173.757 4.68555 173.711 4.73395C173.668 4.78235 173.616 4.82228 173.555 4.85374C173.497 4.8852 173.434 4.90819 173.366 4.92271V4.94086C173.441 4.95538 173.512 4.97958 173.577 5.01346C173.642 5.04492 173.699 5.08606 173.748 5.13688C173.796 5.1877 173.835 5.24941 173.864 5.32201C173.893 5.39219 173.907 5.47205 173.907 5.56159C173.907 5.67291 173.884 5.77455 173.838 5.86651C173.792 5.95847 173.727 6.03712 173.642 6.10246C173.56 6.1678 173.46 6.21862 173.341 6.25492C173.225 6.2888 173.094 6.30574 172.949 6.30574C172.828 6.30574 172.72 6.29243 172.626 6.26581C172.532 6.24161 172.448 6.20773 172.375 6.16417C172.303 6.12061 172.24 6.071 172.187 6.01534C172.133 5.95726 172.086 5.89797 172.045 5.83747L172.397 5.56522C172.458 5.66686 172.529 5.75035 172.611 5.81569C172.696 5.88103 172.811 5.9137 172.956 5.9137C173.101 5.9137 173.213 5.88103 173.29 5.81569C173.37 5.74793 173.41 5.65476 173.41 5.53618V5.50714C173.41 5.39098 173.368 5.30265 173.283 5.24215C173.198 5.17923 173.078 5.14777 172.924 5.14777H172.67V4.7521H172.92ZM176.12 4.6795C176.12 4.861 176.092 5.03282 176.037 5.19496C175.981 5.35468 175.908 5.5023 175.819 5.63782C175.732 5.77092 175.634 5.89071 175.525 5.99719C175.416 6.10367 175.307 6.192 175.198 6.26218H174.552C174.705 6.1557 174.84 6.05406 174.959 5.95726C175.08 5.85804 175.184 5.75761 175.271 5.65597C175.36 5.55433 175.434 5.44906 175.492 5.34016C175.553 5.22884 175.597 5.10784 175.627 4.97716L175.597 4.9699C175.573 5.0183 175.544 5.06549 175.51 5.11147C175.476 5.15745 175.435 5.19738 175.387 5.23126C175.341 5.26514 175.287 5.29297 175.224 5.31475C175.163 5.33411 175.092 5.34379 175.009 5.34379C174.903 5.34379 174.804 5.32564 174.712 5.28934C174.62 5.25304 174.54 5.20101 174.472 5.13325C174.404 5.06307 174.351 4.97958 174.312 4.88278C174.276 4.78598 174.258 4.67708 174.258 4.55608C174.258 4.42782 174.28 4.31045 174.323 4.20397C174.367 4.09749 174.429 4.00553 174.508 3.92809C174.591 3.85065 174.689 3.79136 174.803 3.75022C174.919 3.70666 175.047 3.68488 175.187 3.68488C175.335 3.68488 175.466 3.70908 175.579 3.75748C175.696 3.80346 175.794 3.87001 175.873 3.95713C175.953 4.04183 176.014 4.14589 176.055 4.26931C176.098 4.39031 176.12 4.52704 176.12 4.6795ZM175.191 4.97716C175.329 4.97716 175.437 4.93965 175.514 4.86463C175.591 4.78961 175.63 4.68192 175.63 4.54156V4.498C175.63 4.35764 175.593 4.24995 175.518 4.17493C175.443 4.09749 175.334 4.05877 175.191 4.05877C175.046 4.05877 174.936 4.09749 174.861 4.17493C174.786 4.24995 174.748 4.35764 174.748 4.498V4.54156C174.748 4.68192 174.786 4.78961 174.861 4.86463C174.938 4.93965 175.048 4.97716 175.191 4.97716ZM178.753 3.72844H179.635C179.874 3.72844 180.058 3.78894 180.187 3.90994C180.317 4.02852 180.383 4.19066 180.383 4.39636C180.383 4.54156 180.346 4.65772 180.274 4.74484C180.204 4.83196 180.103 4.89488 179.972 4.9336V4.95175C180.125 4.98805 180.245 5.0546 180.332 5.1514C180.421 5.24578 180.466 5.38009 180.466 5.55433C180.466 5.66081 180.448 5.75761 180.412 5.84473C180.378 5.92943 180.328 6.00324 180.263 6.06616C180.2 6.12908 180.122 6.17748 180.031 6.21136C179.941 6.24524 179.839 6.26218 179.726 6.26218H178.753V3.72844ZM179.58 5.91733C179.713 5.91733 179.813 5.89313 179.878 5.84473C179.946 5.79391 179.98 5.708 179.98 5.587V5.46721C179.98 5.34863 179.946 5.26514 179.878 5.21674C179.813 5.16592 179.713 5.14051 179.58 5.14051H179.217V5.91733H179.58ZM179.519 4.81018C179.647 4.81018 179.741 4.78719 179.802 4.74121C179.865 4.69523 179.896 4.61537 179.896 4.50163V4.38184C179.896 4.2681 179.865 4.18824 179.802 4.14226C179.741 4.09628 179.647 4.07329 179.519 4.07329H179.217V4.81018H179.519ZM181.34 3.72844V5.30749C181.34 5.40187 181.342 5.48657 181.347 5.56159C181.354 5.63661 181.37 5.70074 181.394 5.75398C181.421 5.8048 181.459 5.84473 181.51 5.87377C181.563 5.90281 181.636 5.91733 181.728 5.91733C181.82 5.91733 181.891 5.90281 181.942 5.87377C181.995 5.84473 182.034 5.8048 182.058 5.75398C182.085 5.70074 182.101 5.63661 182.105 5.56159C182.113 5.48657 182.116 5.40187 182.116 5.30749V3.72844H182.592V5.23489C182.592 5.41397 182.581 5.57006 182.559 5.70316C182.537 5.83626 182.495 5.94758 182.432 6.03712C182.369 6.12666 182.281 6.19442 182.167 6.2404C182.056 6.28396 181.909 6.30574 181.728 6.30574C181.546 6.30574 181.399 6.28396 181.285 6.2404C181.174 6.19442 181.087 6.12666 181.024 6.03712C180.961 5.94758 180.918 5.83626 180.897 5.70316C180.875 5.57006 180.864 5.41397 180.864 5.23489V3.72844H181.34ZM183.099 6.26218V5.90644H183.669V4.08418H183.099V3.72844H184.71V4.08418H184.14V5.90644H184.71V6.26218H183.099ZM185.355 6.26218V3.72844H185.831V5.87014H186.952V6.26218H185.355ZM187.434 3.72844H188.221C188.551 3.72844 188.795 3.83734 188.955 4.05514C189.117 4.27294 189.198 4.58633 189.198 4.99531C189.198 5.40671 189.117 5.72131 188.955 5.93911C188.795 6.15449 188.551 6.26218 188.221 6.26218H187.434V3.72844ZM188.189 5.88103C188.363 5.88103 188.491 5.82416 188.573 5.71042C188.658 5.59668 188.701 5.43091 188.701 5.21311V4.77388C188.701 4.5585 188.658 4.39394 188.573 4.2802C188.491 4.16646 188.363 4.10959 188.189 4.10959H187.902V5.88103H188.189ZM189.628 6.26218V5.90644H190.198V4.08418H189.628V3.72844H191.24V4.08418H190.67V5.90644H191.24V6.26218H189.628ZM192.208 4.44355H192.172V6.26218H191.765V3.72844H192.349L193.014 5.54707H193.05V3.72844H193.457V6.26218H192.872L192.208 4.44355ZM195.227 5.91007H195.198C195.176 5.96089 195.149 6.0105 195.118 6.0589C195.086 6.1073 195.048 6.14965 195.002 6.18595C194.956 6.22225 194.901 6.25129 194.838 6.27307C194.778 6.29485 194.708 6.30574 194.628 6.30574C194.371 6.30574 194.176 6.19321 194.043 5.96815C193.913 5.74067 193.847 5.42244 193.847 5.01346C193.847 4.5827 193.925 4.25358 194.08 4.0261C194.234 3.79862 194.473 3.68488 194.795 3.68488C194.921 3.68488 195.031 3.70182 195.125 3.7357C195.222 3.76958 195.304 3.81677 195.372 3.87727C195.442 3.93777 195.499 4.01037 195.542 4.09507C195.588 4.17735 195.625 4.26689 195.651 4.36369L195.216 4.48711C195.199 4.43387 195.179 4.38184 195.158 4.33102C195.138 4.2802 195.112 4.23664 195.078 4.20034C195.046 4.16162 195.008 4.13137 194.962 4.10959C194.916 4.08539 194.859 4.07329 194.791 4.07329C194.634 4.07329 194.521 4.13621 194.453 4.26205C194.386 4.38789 194.352 4.55971 194.352 4.77751V5.18407C194.352 5.29297 194.359 5.3934 194.374 5.48536C194.391 5.5749 194.417 5.65234 194.453 5.71768C194.49 5.78302 194.537 5.83384 194.595 5.87014C194.653 5.90402 194.726 5.92096 194.813 5.92096C194.948 5.92096 195.051 5.88103 195.121 5.80117C195.192 5.71889 195.227 5.61483 195.227 5.48899V5.28208H194.766V4.93723H195.651V6.26218H195.227V5.91007ZM196.935 6.30574C196.717 6.30574 196.531 6.26823 196.376 6.19321C196.223 6.11819 196.099 6.01897 196.002 5.89555L196.289 5.59789C196.383 5.70679 196.485 5.78786 196.594 5.8411C196.705 5.89192 196.824 5.91733 196.949 5.91733C197.095 5.91733 197.206 5.88466 197.283 5.81932C197.361 5.75398 197.4 5.6596 197.4 5.53618C197.4 5.43454 197.371 5.35831 197.312 5.30749C197.254 5.25425 197.156 5.21674 197.018 5.19496L196.75 5.1514C196.515 5.11026 196.348 5.02556 196.249 4.8973C196.15 4.76662 196.1 4.61295 196.1 4.43629C196.1 4.19429 196.179 4.00916 196.336 3.8809C196.493 3.75022 196.711 3.68488 196.989 3.68488C197.188 3.68488 197.358 3.71634 197.501 3.77926C197.646 3.84218 197.763 3.92809 197.85 4.03699L197.57 4.33465C197.502 4.25479 197.421 4.19187 197.327 4.14589C197.233 4.09749 197.121 4.07329 196.993 4.07329C196.717 4.07329 196.579 4.18703 196.579 4.41451C196.579 4.51131 196.608 4.58512 196.666 4.63594C196.724 4.68676 196.824 4.72427 196.964 4.74847L197.229 4.79566C197.449 4.8368 197.613 4.91787 197.719 5.03887C197.826 5.15987 197.879 5.31475 197.879 5.50351C197.879 5.62209 197.858 5.73099 197.817 5.83021C197.776 5.92701 197.715 6.01171 197.636 6.08431C197.556 6.15449 197.456 6.20894 197.338 6.24766C197.222 6.28638 197.087 6.30574 196.935 6.30574Z",
    fill: "#FAF7F3"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_1133_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67041 29.7309C9.67041 28.6263 10.5658 27.7309 11.6704 27.7309H26.9204C28.025 27.7309 28.9204 28.6263 28.9204 29.7309V44.9809C28.9204 46.0855 28.025 46.9809 26.9204 46.9809H11.6704C10.5658 46.9809 9.67041 46.0855 9.67041 44.9809V29.7309Z",
    fill: "url(#paint5_radial_1133_595)",
    fillOpacity: 0.6
  }))), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67041 29.7309C9.67041 28.6263 10.5658 27.7309 11.6704 27.7309H26.9172C28.0218 27.7309 28.9172 28.6263 28.9172 29.7309V32.5709H9.67041V29.7309Z",
    fill: "#455E52"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-360-inside-11_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2491 34.0699H18.2578V36.1709L18.0625 36.385C17.9482 36.5104 17.8848 36.674 17.8848 36.8436V37.3059H22.125C22.3952 37.3059 22.6141 37.0869 22.6141 36.8168C22.6141 36.6644 22.5572 36.5175 22.4545 36.4048L20.6518 34.4282C20.5437 34.3097 20.3964 34.2505 20.2491 34.2506V34.0699Z"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2491 34.0699H18.2578V36.1709L18.0625 36.385C17.9482 36.5104 17.8848 36.674 17.8848 36.8436V37.3059H22.125C22.3952 37.3059 22.6141 37.0869 22.6141 36.8168C22.6141 36.6644 22.5572 36.5175 22.4545 36.4048L20.6518 34.4282C20.5437 34.3097 20.3964 34.2505 20.2491 34.2506V34.0699Z",
    fill: "#678D7C"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2578 34.0699V33.9338H18.1217V34.0699H18.2578ZM20.2491 34.0699H20.3852V33.9338H20.2491V34.0699ZM18.2578 36.1709L18.3584 36.2626L18.3939 36.2236V36.1709H18.2578ZM18.0625 36.385L18.1631 36.4767H18.1631L18.0625 36.385ZM17.8848 37.3059H17.7486V37.442H17.8848V37.3059ZM22.4545 36.4048L22.3539 36.4966L22.4545 36.4048ZM20.6518 34.4282L20.5512 34.5199L20.6518 34.4282ZM20.2491 34.2506H20.113V34.3868L20.2492 34.3867L20.2491 34.2506ZM18.2578 34.2061H20.2491V33.9338H18.2578V34.2061ZM18.3939 36.1709V34.0699H18.1217V36.1709H18.3939ZM18.1631 36.4767L18.3584 36.2626L18.1572 36.0791L17.9619 36.2933L18.1631 36.4767ZM18.0209 36.8436C18.0209 36.7079 18.0716 36.577 18.1631 36.4767L17.9619 36.2933C17.8247 36.4437 17.7486 36.64 17.7486 36.8436H18.0209ZM18.0209 37.3059V36.8436H17.7486V37.3059H18.0209ZM22.125 37.1698H17.8848V37.442H22.125V37.1698ZM22.478 36.8168C22.478 37.0117 22.32 37.1698 22.125 37.1698V37.442C22.4703 37.442 22.7503 37.1621 22.7503 36.8168H22.478ZM22.3539 36.4966C22.4337 36.5841 22.478 36.6983 22.478 36.8168H22.7503C22.7503 36.6304 22.6806 36.4508 22.5551 36.3131L22.3539 36.4966ZM20.5512 34.5199L22.3539 36.4966L22.5551 36.3131L20.7523 34.3364L20.5512 34.5199ZM20.2492 34.3867C20.3599 34.3866 20.4701 34.431 20.5512 34.5199L20.7523 34.3364C20.6173 34.1884 20.4329 34.1143 20.249 34.1144L20.2492 34.3867ZM20.113 34.0699V34.2506H20.3852V34.0699H20.113Z",
    fill: "#161E1A",
    mask: "url(#path-360-inside-11_1133_595)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1184 39.2712C18.1184 38.4066 18.8192 37.7058 19.6838 37.7058H20.9802C21.8448 37.7058 22.5457 38.4066 22.5457 39.2712V42.9323C22.5457 43.7969 21.8448 44.4977 20.9802 44.4977H19.6838C18.8192 44.4977 18.1184 43.7969 18.1184 42.9323V39.2712Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9761 38.1822C15.9761 37.8815 16.2199 37.6377 16.5206 37.6377H19.995C20.2957 37.6377 20.5395 37.8815 20.5395 38.1822V44.2754H15.9761V38.1822Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.136125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 41.4596C16.5007 41.1964 16.714 40.9831 16.9771 40.9831H18.2528C18.5159 40.9831 18.7292 41.1964 18.7292 41.4596V42.3405H16.5007V41.4596Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 39.2193C16.5007 38.9562 16.714 38.7429 16.9771 38.7429H18.2528C18.5159 38.7429 18.7292 38.9562 18.7292 39.2193V40.1002H16.5007V39.2193Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0732 39.2141C19.0732 38.9539 19.2842 38.7429 19.5444 38.7429C19.8047 38.7429 20.0157 38.9539 20.0157 39.2141V40.1002H19.0732V39.2141Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1052 39.2142C21.1052 38.9539 21.3162 38.7429 21.5764 38.7429C21.8367 38.7429 22.0477 38.9539 22.0477 39.2142V40.1003H21.1052V39.2142Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1052 41.4544C21.1052 41.1941 21.3162 40.9831 21.5764 40.9831C21.8367 40.9831 22.0477 41.1941 22.0477 41.4544V42.3405H21.1052V41.4544Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0725 41.4544C19.0725 41.1941 19.2834 40.9831 19.5437 40.9831C19.804 40.9831 20.015 41.1941 20.015 41.4544V42.3405H19.0725V41.4544Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 15.007,
    y: 44.2605,
    width: 8.57586,
    height: 0.693589,
    rx: 0.346795,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.136125
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6357 34.2773C17.6357 34.1857 17.5614 34.1114 17.4698 34.1114C17.3782 34.1114 17.3039 34.1857 17.3039 34.2773V35.6879C17.3039 35.7795 17.3782 35.8538 17.4698 35.8538C17.5614 35.8538 17.6357 35.7795 17.6357 35.6879V34.2773Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9717 34.9411C16.9717 34.8495 16.8974 34.7752 16.8057 34.7752C16.7141 34.7752 16.6398 34.8495 16.6398 34.9411V36.1027C16.6398 36.1944 16.7141 36.2687 16.8057 36.2687C16.8974 36.2687 16.9717 36.1944 16.9717 36.1027V34.9411Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.136125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1298 36.4051L17.849 34.4514C18.0658 34.2051 18.4497 34.2051 18.6665 34.4514L20.3858 36.4051C20.4848 36.5177 20.5395 36.6625 20.5395 36.8125C20.5395 37.0849 20.3186 37.3058 20.0462 37.3058H16.4694C16.1969 37.3058 15.9761 37.0849 15.9761 36.8125C15.9761 36.6625 16.0307 36.5177 16.1298 36.4051Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.136125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4721 29.4139H13.9972C14.2166 29.4139 14.3796 29.4865 14.486 29.6317C14.5941 29.7769 14.6482 29.9858 14.6482 30.2585C14.6482 30.5327 14.5941 30.7425 14.486 30.8877C14.3796 31.0313 14.2166 31.1031 13.9972 31.1031H13.4721V29.4139ZM13.9754 30.849C14.0916 30.849 14.1771 30.811 14.2319 30.7352C14.2884 30.6594 14.3166 30.5489 14.3166 30.4037V30.1109C14.3166 29.9673 14.2884 29.8576 14.2319 29.7817C14.1771 29.7059 14.0916 29.668 13.9754 29.668H13.7842V30.849H13.9754ZM14.9473 31.1031V29.4139H16.0145V29.6753H15.2643V30.1157H15.9879V30.3771H15.2643V30.8417H16.0145V31.1031H14.9473ZM16.9671 31.1321C16.7461 31.1321 16.5823 31.0563 16.4758 30.9046C16.371 30.753 16.3185 30.5376 16.3185 30.2585C16.3185 29.981 16.371 29.7664 16.4758 29.6148C16.5823 29.4615 16.7461 29.3849 16.9671 29.3849C17.051 29.3849 17.1244 29.3962 17.1873 29.4187C17.2518 29.4413 17.3075 29.4728 17.3543 29.5131C17.4011 29.5518 17.4398 29.5994 17.4704 29.6559C17.5011 29.7108 17.5253 29.7713 17.543 29.8374L17.2526 29.9197C17.2413 29.881 17.2284 29.8447 17.2139 29.8108C17.1994 29.7769 17.1808 29.7479 17.1583 29.7237C17.1373 29.6978 17.1107 29.6785 17.0784 29.6656C17.0461 29.6511 17.0074 29.6438 16.9622 29.6438C16.8525 29.6438 16.7735 29.6857 16.7251 29.7696C16.6783 29.8535 16.6549 29.9681 16.6549 30.1133V30.4037C16.6549 30.5489 16.6783 30.6634 16.7251 30.7473C16.7735 30.8312 16.8525 30.8732 16.9622 30.8732C17.0074 30.8732 17.0461 30.8667 17.0784 30.8538C17.1107 30.8393 17.1373 30.8199 17.1583 30.7957C17.1808 30.7699 17.1994 30.7401 17.2139 30.7062C17.2284 30.6723 17.2413 30.636 17.2526 30.5973L17.543 30.6796C17.5253 30.7457 17.5011 30.807 17.4704 30.8635C17.4398 30.9183 17.4011 30.9659 17.3543 31.0063C17.3075 31.045 17.2518 31.0756 17.1873 31.0982C17.1244 31.1208 17.051 31.1321 16.9671 31.1321ZM20.4306 31.1031H19.24V30.8078L19.7821 30.3456C19.8724 30.2682 19.9394 30.198 19.9829 30.1351C20.0265 30.0705 20.0483 30.002 20.0483 29.9294V29.9052C20.0483 29.8245 20.0257 29.7632 19.9805 29.7212C19.9353 29.6793 19.8724 29.6583 19.7917 29.6583C19.703 29.6583 19.6353 29.6825 19.5885 29.7309C19.5417 29.7793 19.5078 29.839 19.4868 29.91L19.2109 29.8059C19.2287 29.7511 19.2537 29.6987 19.286 29.6486C19.3198 29.597 19.361 29.5518 19.4094 29.5131C19.4594 29.4744 19.5183 29.4437 19.586 29.4212C19.6538 29.397 19.7312 29.3849 19.8184 29.3849C19.9087 29.3849 19.9886 29.3978 20.0579 29.4236C20.1289 29.4478 20.1886 29.4825 20.237 29.5276C20.2854 29.5712 20.3217 29.6236 20.3459 29.6849C20.3717 29.7462 20.3846 29.8132 20.3846 29.8858C20.3846 29.9552 20.3734 30.0189 20.3508 30.077C20.3298 30.1351 20.2999 30.1907 20.2612 30.244C20.2225 30.2956 20.1765 30.3456 20.1233 30.394C20.0717 30.4424 20.0152 30.4908 19.9539 30.5392L19.586 30.8369H20.4306V31.1031ZM21.2767 31.1321C21.167 31.1321 21.0718 31.1127 20.9911 31.074C20.9105 31.0337 20.8435 30.9764 20.7903 30.9022C20.7386 30.828 20.6999 30.7368 20.6741 30.6287C20.6499 30.5206 20.6378 30.3972 20.6378 30.2585C20.6378 30.1213 20.6499 29.9987 20.6741 29.8906C20.6999 29.7809 20.7386 29.689 20.7903 29.6148C20.8435 29.5405 20.9105 29.4841 20.9911 29.4454C21.0718 29.405 21.167 29.3849 21.2767 29.3849C21.4961 29.3849 21.6574 29.4615 21.7607 29.6148C21.8639 29.768 21.9156 29.9826 21.9156 30.2585C21.9156 30.5344 21.8639 30.7489 21.7607 30.9022C21.6574 31.0555 21.4961 31.1321 21.2767 31.1321ZM21.2767 30.878C21.3928 30.878 21.4743 30.8369 21.5211 30.7546C21.5695 30.6707 21.5937 30.5553 21.5937 30.4085V30.1084C21.5937 29.9616 21.5695 29.8471 21.5211 29.7648C21.4743 29.6809 21.3928 29.639 21.2767 29.639C21.1605 29.639 21.0782 29.6809 21.0298 29.7648C20.9831 29.8471 20.9597 29.9616 20.9597 30.1084V30.4085C20.9597 30.5553 20.9831 30.6707 21.0298 30.7546C21.0782 30.8369 21.1605 30.878 21.2767 30.878ZM21.2767 30.4013C21.2202 30.4013 21.1807 30.39 21.1581 30.3674C21.1371 30.3448 21.1266 30.3174 21.1266 30.2851V30.2319C21.1266 30.1996 21.1371 30.1722 21.1581 30.1496C21.1807 30.127 21.2202 30.1157 21.2767 30.1157C21.3331 30.1157 21.3719 30.127 21.3928 30.1496C21.4154 30.1722 21.4267 30.1996 21.4267 30.2319V30.2851C21.4267 30.3174 21.4154 30.3448 21.3928 30.3674C21.3719 30.39 21.3331 30.4013 21.2767 30.4013ZM23.3327 31.1031H22.1421V30.8078L22.6842 30.3456C22.7745 30.2682 22.8415 30.198 22.885 30.1351C22.9286 30.0705 22.9504 30.002 22.9504 29.9294V29.9052C22.9504 29.8245 22.9278 29.7632 22.8826 29.7212C22.8374 29.6793 22.7745 29.6583 22.6939 29.6583C22.6051 29.6583 22.5374 29.6825 22.4906 29.7309C22.4438 29.7793 22.4099 29.839 22.3889 29.91L22.1131 29.8059C22.1308 29.7511 22.1558 29.6987 22.1881 29.6486C22.222 29.597 22.2631 29.5518 22.3115 29.5131C22.3615 29.4744 22.4204 29.4437 22.4882 29.4212C22.5559 29.397 22.6334 29.3849 22.7205 29.3849C22.8108 29.3849 22.8907 29.3978 22.9601 29.4236C23.031 29.4478 23.0907 29.4825 23.1391 29.5276C23.1875 29.5712 23.2238 29.6236 23.248 29.6849C23.2738 29.7462 23.2868 29.8132 23.2868 29.8858C23.2868 29.9552 23.2755 30.0189 23.2529 30.077C23.2319 30.1351 23.2021 30.1907 23.1633 30.244C23.1246 30.2956 23.0786 30.3456 23.0254 30.394C22.9738 30.4424 22.9173 30.4908 22.856 30.5392L22.4882 30.8369H23.3327V31.1031ZM24.1788 31.1321C24.0691 31.1321 23.9739 31.1127 23.8932 31.074C23.8126 31.0337 23.7456 30.9764 23.6924 30.9022C23.6407 30.828 23.602 30.7368 23.5762 30.6287C23.552 30.5206 23.5399 30.3972 23.5399 30.2585C23.5399 30.1213 23.552 29.9987 23.5762 29.8906C23.602 29.7809 23.6407 29.689 23.6924 29.6148C23.7456 29.5405 23.8126 29.4841 23.8932 29.4454C23.9739 29.405 24.0691 29.3849 24.1788 29.3849C24.3982 29.3849 24.5595 29.4615 24.6628 29.6148C24.766 29.768 24.8177 29.9826 24.8177 30.2585C24.8177 30.5344 24.766 30.7489 24.6628 30.9022C24.5595 31.0555 24.3982 31.1321 24.1788 31.1321ZM24.1788 30.878C24.2949 30.878 24.3764 30.8369 24.4232 30.7546C24.4716 30.6707 24.4958 30.5553 24.4958 30.4085V30.1084C24.4958 29.9616 24.4716 29.8471 24.4232 29.7648C24.3764 29.6809 24.2949 29.639 24.1788 29.639C24.0626 29.639 23.9803 29.6809 23.9319 29.7648C23.8852 29.8471 23.8618 29.9616 23.8618 30.1084V30.4085C23.8618 30.5553 23.8852 30.6707 23.9319 30.7546C23.9803 30.8369 24.0626 30.878 24.1788 30.878ZM24.1788 30.4013C24.1223 30.4013 24.0828 30.39 24.0602 30.3674C24.0392 30.3448 24.0287 30.3174 24.0287 30.2851V30.2319C24.0287 30.1996 24.0392 30.1722 24.0602 30.1496C24.0828 30.127 24.1223 30.1157 24.1788 30.1157C24.2353 30.1157 24.274 30.127 24.2949 30.1496C24.3175 30.1722 24.3288 30.1996 24.3288 30.2319V30.2851C24.3288 30.3174 24.3175 30.3448 24.2949 30.3674C24.274 30.39 24.2353 30.4013 24.1788 30.4013Z",
    fill: "#FAF7F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.67021,
    cy: 27.7309,
    rx: 1.5125,
    ry: 1.5125,
    fill: "url(#paint6_linear_1133_595)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_1133_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67041 64.4934C9.67041 63.3888 10.5658 62.4934 11.6704 62.4934H26.9204C28.025 62.4934 28.9204 63.3888 28.9204 64.4934V79.7434C28.9204 80.8479 28.025 81.7434 26.9204 81.7434H11.6704C10.5658 81.7434 9.67041 80.8479 9.67041 79.7434V64.4934Z",
    fill: "url(#paint7_radial_1133_595)",
    fillOpacity: 0.6
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67041 64.4934C9.67041 63.3888 10.5658 62.4934 11.6704 62.4934H26.9172C28.0218 62.4934 28.9172 63.3888 28.9172 64.4934V67.3334H9.67041V64.4934Z",
    fill: "#455E52"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.67021,
    cy: 62.4934,
    rx: 1.5125,
    ry: 1.5125,
    fill: "url(#paint8_linear_1133_595)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4046,
    y: 68.5987,
    width: 3.32189,
    height: 11.7148,
    rx: 0.831638,
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8256 69.4303C16.8256 68.951 17.2141 68.5625 17.6934 68.5625H19.352C19.8312 68.5625 20.2198 68.951 20.2198 69.4303V79.9794H16.8256V69.4303Z",
    fill: "#678D7C",
    stroke: "#161E1A",
    strokeWidth: 0.0723163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 69.5499C17.2012 69.3484 17.3646 69.185 17.5662 69.185C17.7677 69.185 17.9311 69.3484 17.9311 69.5499V70.2235H17.2012V69.5499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 71.2162C17.2012 71.0146 17.3646 70.8512 17.5662 70.8512C17.7677 70.8512 17.9311 71.0146 17.9311 71.2162V71.8897H17.2012V71.2162Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 72.8824C17.2012 72.6809 17.3646 72.5175 17.5662 72.5175C17.7677 72.5175 17.9311 72.6809 17.9311 72.8824V73.556H17.2012V72.8824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 74.5487C17.2012 74.3471 17.3646 74.1837 17.5662 74.1837C17.7677 74.1837 17.9311 74.3471 17.9311 74.5487V75.2222H17.2012V74.5487Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 76.2149C17.2012 76.0133 17.3646 75.8499 17.5662 75.8499C17.7677 75.8499 17.9311 76.0133 17.9311 76.2149V76.8885H17.2012V76.2149Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2012 77.8812C17.2012 77.6796 17.3646 77.5162 17.5662 77.5162C17.7677 77.5162 17.9311 77.6796 17.9311 77.8812V78.5547H17.2012V77.8812Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 69.5499C18.1577 69.3484 18.3211 69.185 18.5227 69.185C18.7243 69.185 18.8877 69.3484 18.8877 69.5499V70.2235H18.1577V69.5499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 71.2162C18.1577 71.0146 18.3211 70.8512 18.5227 70.8512C18.7243 70.8512 18.8877 71.0146 18.8877 71.2162V71.8897H18.1577V71.2162Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 72.8824C18.1577 72.6809 18.3211 72.5175 18.5227 72.5175C18.7243 72.5175 18.8877 72.6809 18.8877 72.8824V73.556H18.1577V72.8824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 74.5487C18.1577 74.3471 18.3211 74.1837 18.5227 74.1837C18.7243 74.1837 18.8877 74.3471 18.8877 74.5487V75.2222H18.1577V74.5487Z",
    fill: "#86D383",
    stroke: "#4F7C56",
    strokeWidth: 0.0723163
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 76.2149C18.1577 76.0133 18.3211 75.8499 18.5227 75.8499C18.7243 75.8499 18.8877 76.0133 18.8877 76.2149V76.8885H18.1577V76.2149Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1577 77.8812C18.1577 77.6796 18.3211 77.5162 18.5227 77.5162C18.7243 77.5162 18.8877 77.6796 18.8877 77.8812V78.5547H18.1577V77.8812Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1143 69.5499C19.1143 69.3484 19.2777 69.185 19.4793 69.185C19.6808 69.185 19.8442 69.3484 19.8442 69.5499V70.2235H19.1143V69.5499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 69.5499C20.6262 69.3484 20.7897 69.185 20.9912 69.185C21.1928 69.185 21.3562 69.3484 21.3562 69.5499V70.2235H20.6262V69.5499Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 71.2162C20.6262 71.0146 20.7897 70.8512 20.9912 70.8512C21.1928 70.8512 21.3562 71.0146 21.3562 71.2162V71.8897H20.6262V71.2162Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 72.8824C20.6262 72.6809 20.7897 72.5175 20.9912 72.5175C21.1928 72.5175 21.3562 72.6809 21.3562 72.8824V73.556H20.6262V72.8824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 74.5487C20.6262 74.3471 20.7897 74.1837 20.9912 74.1837C21.1928 74.1837 21.3562 74.3471 21.3562 74.5487V75.2222H20.6262V74.5487Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 76.2149C20.6262 76.0133 20.7897 75.8499 20.9912 75.8499C21.1928 75.8499 21.3562 76.0133 21.3562 76.2149V76.8885H20.6262V76.2149Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6262 77.8812C20.6262 77.6796 20.7897 77.5162 20.9912 77.5162C21.1928 77.5162 21.3562 77.6796 21.3562 77.8812V78.5547H20.6262V77.8812Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1143 71.2162C19.1143 71.0146 19.2777 70.8512 19.4793 70.8512C19.6808 70.8512 19.8442 71.0146 19.8442 71.2162V71.8897H19.1143V71.2162Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1143 72.8824C19.1143 72.6809 19.2777 72.5175 19.4793 72.5175C19.6808 72.5175 19.8442 72.6809 19.8442 72.8824V73.556H19.1143V72.8824Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1143 74.5487C19.1143 74.3471 19.2777 74.1837 19.4793 74.1837C19.6808 74.1837 19.8442 74.3471 19.8442 74.5487V75.2222H19.1143V74.5487Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1143 76.2149C19.1143 76.0133 19.2777 75.8499 19.4793 75.8499C19.6808 75.8499 19.8442 76.0133 19.8442 76.2149V76.8885H19.1143V76.2149Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1143 77.8812C19.1143 77.6796 19.2777 77.5162 19.4793 77.5162C19.6808 77.5162 19.8442 77.6796 19.8442 77.8812V78.5547H19.1143V77.8812Z",
    fill: "#597364",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-405-inside-12_1133_595",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1216 74.5487C18.1216 74.3271 18.3012 74.1475 18.5227 74.1475C18.7443 74.1475 18.9238 74.3271 18.9238 74.5487V75.2584H18.1216V74.5487Z"
  }))), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1216 74.5487C18.1216 74.3271 18.3012 74.1475 18.5227 74.1475C18.7443 74.1475 18.9238 74.3271 18.9238 74.5487V75.2584H18.1216V74.5487Z",
    fill: "#597364"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9238 75.2584V75.3307H18.9962V75.2584H18.9238ZM18.1216 75.2584H18.0493V75.3307H18.1216V75.2584ZM18.8515 74.5487V75.2584H18.9962V74.5487H18.8515ZM18.9238 75.1861H18.1216V75.3307H18.9238V75.1861ZM18.1939 75.2584V74.5487H18.0493V75.2584H18.1939ZM18.5227 74.2199C18.7043 74.2199 18.8515 74.3671 18.8515 74.5487H18.9962C18.9962 74.2872 18.7842 74.0752 18.5227 74.0752V74.2199ZM18.5227 74.0752C18.2612 74.0752 18.0493 74.2872 18.0493 74.5487H18.1939C18.1939 74.3671 18.3411 74.2199 18.5227 74.2199V74.0752Z",
    fill: "#161E1A",
    mask: "url(#path-405-inside-12_1133_595)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0904,
    y: 79.9539,
    width: 6.40753,
    height: 0.544812,
    rx: 0.272406,
    fill: "#4F5B55",
    stroke: "#161E1A",
    strokeWidth: 0.0723163
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3539 65.0839L14.3684 64.5951H14.3466L14.0199 65.4638L13.6932 64.5951H13.6715L13.686 65.0839V65.8656H13.4101V64.1764H13.7876L14.0224 64.7983H14.0393L14.2765 64.1764H14.6298V65.8656H14.3539V65.0839ZM15.8316 65.8656L15.713 65.4372H15.2121L15.0959 65.8656H14.7765L15.2508 64.1764H15.6912L16.168 65.8656H15.8316ZM15.4734 64.4886H15.4541L15.2677 65.1783H15.6598L15.4734 64.4886ZM16.7648 65.8656V65.2485L16.2154 64.1764H16.5687L16.7648 64.583L16.9172 64.929H16.9342L17.089 64.583L17.2875 64.1764H17.6287L17.0794 65.2485V65.8656H16.7648ZM20.4292 65.8656H19.2385V65.5703L19.7806 65.1081C19.8709 65.0307 19.9379 64.9605 19.9815 64.8976C20.025 64.833 20.0468 64.7645 20.0468 64.6919V64.6677C20.0468 64.587 20.0242 64.5257 19.979 64.4837C19.9339 64.4418 19.8709 64.4208 19.7903 64.4208C19.7015 64.4208 19.6338 64.445 19.587 64.4934C19.5402 64.5418 19.5063 64.6015 19.4854 64.6725L19.2095 64.5684C19.2272 64.5136 19.2522 64.4611 19.2845 64.4111C19.3184 64.3595 19.3595 64.3143 19.4079 64.2756C19.4579 64.2369 19.5168 64.2062 19.5846 64.1837C19.6523 64.1595 19.7298 64.1474 19.8169 64.1474C19.9072 64.1474 19.9871 64.1603 20.0565 64.1861C20.1275 64.2103 20.1872 64.245 20.2356 64.2901C20.284 64.3337 20.3203 64.3861 20.3445 64.4474C20.3703 64.5087 20.3832 64.5757 20.3832 64.6483C20.3832 64.7177 20.3719 64.7814 20.3493 64.8395C20.3283 64.8976 20.2985 64.9532 20.2598 65.0065C20.221 65.0581 20.1751 65.1081 20.1218 65.1565C20.0702 65.2049 20.0137 65.2533 19.9524 65.3017L19.5846 65.5994H20.4292V65.8656ZM21.2752 65.8946C21.1655 65.8946 21.0703 65.8752 20.9897 65.8365C20.909 65.7962 20.842 65.7389 20.7888 65.6647C20.7372 65.5905 20.6984 65.4993 20.6726 65.3912C20.6484 65.2831 20.6363 65.1597 20.6363 65.021C20.6363 64.8838 20.6484 64.7612 20.6726 64.6531C20.6984 64.5434 20.7372 64.4515 20.7888 64.3773C20.842 64.303 20.909 64.2466 20.9897 64.2079C21.0703 64.1675 21.1655 64.1474 21.2752 64.1474C21.4946 64.1474 21.656 64.224 21.7592 64.3773C21.8625 64.5305 21.9141 64.7451 21.9141 65.021C21.9141 65.2969 21.8625 65.5114 21.7592 65.6647C21.656 65.818 21.4946 65.8946 21.2752 65.8946ZM21.2752 65.6405C21.3914 65.6405 21.4728 65.5994 21.5196 65.5171C21.568 65.4332 21.5922 65.3178 21.5922 65.171V64.8709C21.5922 64.7241 21.568 64.6096 21.5196 64.5273C21.4728 64.4434 21.3914 64.4015 21.2752 64.4015C21.1591 64.4015 21.0768 64.4434 21.0284 64.5273C20.9816 64.6096 20.9582 64.7241 20.9582 64.8709V65.171C20.9582 65.3178 20.9816 65.4332 21.0284 65.5171C21.0768 65.5994 21.1591 65.6405 21.2752 65.6405ZM21.2752 65.1638C21.2187 65.1638 21.1792 65.1525 21.1566 65.1299C21.1357 65.1073 21.1252 65.0799 21.1252 65.0476V64.9944C21.1252 64.9621 21.1357 64.9347 21.1566 64.9121C21.1792 64.8895 21.2187 64.8782 21.2752 64.8782C21.3317 64.8782 21.3704 64.8895 21.3914 64.9121C21.414 64.9347 21.4253 64.9621 21.4253 64.9944V65.0476C21.4253 65.0799 21.414 65.1073 21.3914 65.1299C21.3704 65.1525 21.3317 65.1638 21.2752 65.1638ZM23.3313 65.8656H22.1406V65.5703L22.6827 65.1081C22.7731 65.0307 22.84 64.9605 22.8836 64.8976C22.9271 64.833 22.9489 64.7645 22.9489 64.6919V64.6677C22.9489 64.587 22.9263 64.5257 22.8811 64.4837C22.836 64.4418 22.7731 64.4208 22.6924 64.4208C22.6037 64.4208 22.5359 64.445 22.4891 64.4934C22.4423 64.5418 22.4084 64.6015 22.3875 64.6725L22.1116 64.5684C22.1293 64.5136 22.1543 64.4611 22.1866 64.4111C22.2205 64.3595 22.2616 64.3143 22.31 64.2756C22.36 64.2369 22.4189 64.2062 22.4867 64.1837C22.5544 64.1595 22.6319 64.1474 22.719 64.1474C22.8094 64.1474 22.8892 64.1603 22.9586 64.1861C23.0296 64.2103 23.0893 64.245 23.1377 64.2901C23.1861 64.3337 23.2224 64.3861 23.2466 64.4474C23.2724 64.5087 23.2853 64.5757 23.2853 64.6483C23.2853 64.7177 23.274 64.7814 23.2514 64.8395C23.2304 64.8976 23.2006 64.9532 23.1619 65.0065C23.1231 65.0581 23.0772 65.1081 23.0239 65.1565C22.9723 65.2049 22.9158 65.2533 22.8545 65.3017L22.4867 65.5994H23.3313V65.8656ZM23.6715 65.8656V65.6066H24.1362V64.4063H24.1144L23.7466 64.8419L23.5481 64.6749L23.9668 64.1764H24.4532V65.6066H24.8356V65.8656H23.6715Z",
    fill: "#FAF7F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1133_595",
    x: -15.84,
    y: -9.84003,
    width: 229.734,
    height: 129.823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1133_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1133_595",
    x: 28.493,
    y: -15.84,
    width: 191.401,
    height: 126.819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.219608 0 0 0 0 0.192157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1133_595",
    result: "effect2_dropShadow_1133_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1133_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1133_595",
    x: 28.5482,
    y: -15.84,
    width: 191.401,
    height: 41.2044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_595"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.219608 0 0 0 0 0.192157 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1133_595",
    result: "effect2_dropShadow_1133_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1133_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_1133_595",
    x: -6.16962,
    y: 11.8908,
    width: 50.9301,
    height: 50.9301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1133_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_1133_595",
    x: -6.16962,
    y: 46.6533,
    width: 50.9301,
    height: 50.9301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.92002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1133_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1133_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1133_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.8357 18.4594) rotate(23.8473) scale(187.218 321.128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1133_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6844 12.0781) rotate(27.984) scale(156.376 300.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1133_595",
    x1: 107.111,
    y1: 37.2435,
    x2: 107.111,
    y2: 84.3493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1133_595",
    x1: 171.682,
    y1: 52.4253,
    x2: 171.682,
    y2: 84.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1133_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.109 9.52438) rotate(-176.587) scale(160.004 39.3682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1133_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.918 30.1747) rotate(41.7341) scale(22.3028 51.3907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1133_595",
    x1: 9.67021,
    y1: 26.2184,
    x2: 9.67021,
    y2: 29.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1133_595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.918 64.9372) rotate(41.7341) scale(22.3028 51.3907)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F6F9",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678D7C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1133_595",
    x1: 9.67021,
    y1: 60.9809,
    x2: 9.67021,
    y2: 64.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F57233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C34827"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.3001f0933bab99b2bb677f514fed65ff.svg";
export { ForwardRef as ReactComponent };